import React, { useEffect, useMemo, useState } from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import api from '../services/api';

const Icons = {
  Building: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 21V5a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v16" />
      <path d="M17 9h1a2 2 0 0 1 2 2v10" />
      <path d="M8 7h5" />
      <path d="M8 11h5" />
      <path d="M8 15h5" />
      <path d="M3 21h18" />
    </svg>
  ),

  Plus: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="12" y1="5" x2="12" y2="19" />
      <line x1="5" y1="12" x2="19" y2="12" />
    </svg>
  ),

  ArrowLeft: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="19" y1="12" x2="5" y2="12" />
      <polyline points="12 19 5 12 12 5" />
    </svg>
  ),

  Upload: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
      <polyline points="17 8 12 3 7 8" />
      <line x1="12" y1="3" x2="12" y2="15" />
    </svg>
  ),

  Edit: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
      <path d="M18.5 2.5a2.12 2.12 0 0 1 3 3L12 15l-4 1 1-4Z" />
    </svg>
  ),

  Pause: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <line x1="10" y1="8" x2="10" y2="16" />
      <line x1="14" y1="8" x2="14" y2="16" />
    </svg>
  ),

  Trash: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="3 6 5 6 21 6" />
      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" />
      <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
    </svg>
  ),

  Phone: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2A19.79 19.79 0 0 1 11.19 18.87a19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.12.9.36 1.78.7 2.61a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.47-1.27a2 2 0 0 1 2.11-.45c.83.34 1.71.58 2.61.7A2 2 0 0 1 22 16.92z" />
    </svg>
  ),

  Mail: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="m3 7 9 6 9-6" />
    </svg>
  ),

  Message: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 11.5a8.5 8.5 0 0 1-12.7 7.4L3 21l2-5.1A8.5 8.5 0 1 1 21 11.5Z" />
      <path d="M8 10h8" />
      <path d="M8 14h5" />
    </svg>
  ),

  External: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
      <path d="M7 17 17 7" />
      <path d="M8 7h9v9" />
    </svg>
  ),

  Shield: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z" />
      <path d="m9 12 2 2 4-5" />
    </svg>
  ),

  Check: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="20 6 9 17 4 12" />
    </svg>
  ),

  Lock: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
      <rect x="4" y="11" width="16" height="10" rx="2" />
      <path d="M8 11V7a4 4 0 0 1 8 0v4" />
    </svg>
  ),

  Clock: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <path d="M12 6v6l4 2" />
    </svg>
  ),

  Alert: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
      <path d="M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z" />
      <path d="M12 9v4" />
      <path d="M12 17h.01" />
    </svg>
  ),

  Power: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 2v10" />
      <path d="M18.4 6.6a9 9 0 1 1-12.8 0" />
    </svg>
  ),

  Refresh: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 12a9 9 0 0 1-15.4 6.4L3 16" />
      <path d="M3 21v-5h5" />
      <path d="M3 12A9 9 0 0 1 18.4 5.6L21 8" />
      <path d="M21 3v5h-5" />
    </svg>
  ),

  Qr: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="7" height="7" rx="1" />
      <rect x="14" y="3" width="7" height="7" rx="1" />
      <rect x="3" y="14" width="7" height="7" rx="1" />
      <path d="M14 14h3v3" />
      <path d="M21 14v7h-7" />
      <path d="M14 21v-3" />
    </svg>
  )
};

const initialForm = {
  nome: '',
  codigoLoja: '',
  unidade: '',
  cnpj: '',
  inscricaoEstadual: '',
  endereco: '',
  telefone: '',
  whatsapp: '',
  email: '',
  linkAvaliacao: '',
  siteUrl: '',
  instagram: '',
  facebook: '',
  corPrimaria: '#111318',
  corSecundaria: '#1a73e8',

  provedorFiscal: 'nfeio',
  ambienteNf: 'homologacao',
  regimeTributario: 'simples_nacional',
  nfeioCompanyId: '',
  nfeioApiKey: '',
  cscId: '',
  cscCodigo: '',
  certificadoSenha: '',
  certificadoA1Nome: '',
  certificadoA1Configurado: false,
  statusAnalise: 'nao_enviado',
  statusFiscal: 'nao_enviado',
  emissaoLiberada: false,
  prontoParaAnalise: false,
  analiseSolicitadaEm: null,
  prazoAnaliseAte: null,
  analisadoEm: null,
  observacaoAnalise: '',
  motivoPendencia: '',
  motivoReprovacao: '',

  ativo: true
};

const REGIMES_TRIBUTARIOS = [
  { value: 'mei', label: 'MEI', crt: '1' },
  { value: 'simples_nacional', label: 'Simples Nacional', crt: '1' },
  { value: 'lucro_presumido', label: 'Lucro Presumido', crt: '3' },
  { value: 'lucro_real', label: 'Lucro Real', crt: '3' }
];

function getRegimeTributarioMeta(value) {
  return REGIMES_TRIBUTARIOS.find((item) => item.value === value) || REGIMES_TRIBUTARIOS[1];
}

const FISCAL_STATUS_META = {
  nao_enviado: {
    label: 'Não enviado',
    title: 'Fiscal não enviado',
    description: 'Preencha os dados fiscais e salve. A análise começa automaticamente.',
    tone: 'neutral'
  },
  em_analise: {
    label: 'Em análise',
    title: 'Fiscal em análise',
    description: 'A Lumix vai conferir os dados e configurar a emissão em até 48 horas.',
    tone: 'warning'
  },
  pendente_ajuste: {
    label: 'Ajuste necessário',
    title: 'Fiscal com pendência',
    description: 'Existe uma informação fiscal que precisa ser corrigida antes da aprovação.',
    tone: 'danger'
  },
  aprovado: {
    label: 'Aprovado',
    title: 'Emissão liberada',
    description: 'Configuração fiscal aprovada. Esta empresa já pode emitir NFC-e.',
    tone: 'success'
  },
  reprovado: {
    label: 'Reprovado',
    title: 'Fiscal reprovado',
    description: 'A configuração fiscal foi reprovada. Revise os dados com o suporte.',
    tone: 'danger'
  }
};

function getFiscalStatus(empOrForm = {}) {
  return (
    empOrForm?.fiscal?.statusAnalise ||
    empOrForm?.fiscal?.statusFiscal ||
    empOrForm?.statusAnalise ||
    empOrForm?.statusFiscal ||
    'nao_enviado'
  );
}

function getFiscalStatusMeta(empOrForm = {}) {
  const status = getFiscalStatus(empOrForm);
  return FISCAL_STATUS_META[status] || FISCAL_STATUS_META.nao_enviado;
}


function formatarDataHora(valor) {
  if (!valor) return '';

  try {
    const data = new Date(valor);

    if (Number.isNaN(data.getTime())) return '';

    return data.toLocaleString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    });
  } catch {
    return '';
  }
}

function getPrazoAnaliseTexto(empOrForm = {}) {
  const prazo =
    empOrForm?.fiscal?.prazoAnaliseAte ||
    empOrForm?.prazoAnaliseAte ||
    null;

  const formatado = formatarDataHora(prazo);

  return formatado ? `Prazo estimado: ${formatado}` : 'Prazo estimado: até 48 horas';
}



function getFiscalMensagemPrincipal(empOrForm = {}) {
  const meta = getFiscalStatusMeta(empOrForm);
  const status = getFiscalStatus(empOrForm);

  if (status === 'em_analise') {
    return getPrazoAnaliseTexto(empOrForm);
  }

  if (status === 'pendente_ajuste') {
    return (
      empOrForm?.fiscal?.motivoPendencia ||
      empOrForm?.motivoPendencia ||
      'Revise as informações fiscais solicitadas.'
    );
  }

  if (status === 'reprovado') {
    return (
      empOrForm?.fiscal?.motivoReprovacao ||
      empOrForm?.motivoReprovacao ||
      'Entre em contato com o suporte para revisar a configuração.'
    );
  }

  if (status === 'aprovado') {
    return 'Empresa liberada para emitir NFC-e.';
  }

  return meta.description;
}

function limparCNPJ(cnpj = '') {
  return String(cnpj || '').replace(/\D/g, '');
}

function formatarCNPJ(cnpj = '') {
  const clean = limparCNPJ(cnpj).slice(0, 14);

  return clean
    .replace(/^(\d{2})(\d)/, '$1.$2')
    .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
    .replace(/\.(\d{3})(\d)/, '.$1/$2')
    .replace(/(\d{4})(\d)/, '$1-$2');
}

function formatarTelefone(valor = '') {
  const clean = String(valor || '').replace(/\D/g, '').slice(0, 11);

  if (clean.length <= 10) {
    return clean
      .replace(/^(\d{2})(\d)/, '($1) $2')
      .replace(/(\d{4})(\d)/, '$1-$2');
  }

  return clean
    .replace(/^(\d{2})(\d)/, '($1) $2')
    .replace(/(\d{5})(\d)/, '$1-$2');
}

function getApiBaseUrl() {
  return String(api.defaults.baseURL || '').replace(/\/$/, '');
}

function formatImageUrl(url) {
  if (!url) return null;
  if (String(url).startsWith('http')) return url;

  return `${getApiBaseUrl()}${url}`;
}

function getFiscalValue(emp, key, fallback = '') {
  return emp?.fiscal?.[key] ?? emp?.[key] ?? fallback;
}

function empresaTemCertificadoA1(emp = {}) {
  return Boolean(
    emp?.fiscal?.certificadoA1Configurado ||
      emp?.fiscal?.temCertificadoA1 ||
      emp?.fiscal?.certificadoA1Nome ||
      emp?.fiscal?.certificadoNome ||
      emp?.fiscal?.certificadoA1Url ||
      emp?.certificadoA1Configurado ||
      emp?.temCertificadoA1 ||
      emp?.certificadoA1Nome ||
      emp?.certificadoNome
  );
}

function getCertificadoA1Nome(emp = {}) {
  return (
    emp?.fiscal?.certificadoA1Nome ||
    emp?.fiscal?.certificadoNome ||
    emp?.certificadoA1Nome ||
    emp?.certificadoNome ||
    ''
  );
}

function certificadoA1Valido(file) {
  if (!file) return false;

  const nome = String(file.name || '').toLowerCase();
  const extensaoOk = nome.endsWith('.pfx') || nome.endsWith('.p12');

  /*
    Alguns navegadores retornam application/octet-stream para .pfx/.p12,
    por isso a validação principal fica pela extensão.
  */
  return extensaoOk;
}

function normalizarResumoPlano(data) {
  const resumo = data?.resumoPlano || data?.plano || {};

  const limite = Number(
    resumo.limiteEmpresas ||
      resumo.quantidadeEmpresas ||
      resumo.limiteCanais ||
      1
  );

  const total = Number(
    resumo.totalEmpresasAtivas ||
      resumo.total ||
      0
  );

  return {
    planoCodigo: resumo.planoCodigo || 'start',
    planoNome: resumo.planoNome || 'Start',
    limiteEmpresas: Number.isFinite(limite) && limite > 0 ? limite : 1,
    quantidadeEmpresas: Number.isFinite(limite) && limite > 0 ? limite : 1,
    totalEmpresasAtivas: Number.isFinite(total) ? total : 0,
    disponiveis: Math.max(0, Number.isFinite(limite) ? limite - total : 0),
    podeCriar:
      resumo.podeCriar !== undefined
        ? Boolean(resumo.podeCriar)
        : total < limite,
    checkoutSessionId: resumo.checkoutSessionId || null
  };
}

function normalizarRespostaEmpresas(data) {
  if (Array.isArray(data)) {
    return {
      empresas: data,
      resumoPlano: {
        planoCodigo: 'start',
        planoNome: 'Start',
        limiteEmpresas: data.length || 1,
        quantidadeEmpresas: data.length || 1,
        totalEmpresasAtivas: data.filter((e) => e.ativo !== false).length,
        disponiveis: 0,
        podeCriar: false,
        checkoutSessionId: null
      }
    };
  }

  return {
    empresas: Array.isArray(data?.empresas) ? data.empresas : [],
    resumoPlano: normalizarResumoPlano(data)
  };
}

function montarFormData(formData, logoFile, certificadoA1File) {
  const data = new FormData();

  const fields = {
    nome: formData.nome,
    codigoLoja: formData.codigoLoja,
    unidade: formData.unidade,
    cnpj: limparCNPJ(formData.cnpj),
    inscricaoEstadual: formData.inscricaoEstadual,
    endereco: formData.endereco,
    telefone: formData.telefone,
    whatsapp: formData.whatsapp,
    email: formData.email,
    linkAvaliacao: formData.linkAvaliacao,
    siteUrl: formData.siteUrl,
    instagram: formData.instagram,
    facebook: formData.facebook,
    corPrimaria: formData.corPrimaria,
    corSecundaria: formData.corSecundaria,

    provedorFiscal: 'nfeio',
    provedor: 'nfeio',
    ambienteNf: formData.ambienteNf,
    regimeTributario: formData.regimeTributario,
    regimeTributarioCodigo: getRegimeTributarioMeta(formData.regimeTributario).crt,
    crt: getRegimeTributarioMeta(formData.regimeTributario).crt,
cscId: formData.cscId,
    cscCodigo: formData.cscCodigo,

    /*
      Enviamos a senha com alguns nomes compatíveis.
      O backend pode usar certificadoSenha, senhaCertificado ou certificadoA1Senha.
    */
    certificadoSenha: formData.certificadoSenha,
    senhaCertificado: formData.certificadoSenha,
    certificadoA1Senha: formData.certificadoSenha,

    ativo: String(Boolean(formData.ativo))
  };

  Object.entries(fields).forEach(([key, value]) => {
    data.append(key, value ?? '');
  });

  if (logoFile) {
    data.append('logo', logoFile);
  }

  if (certificadoA1File) {
    data.append('certificadoA1', certificadoA1File);
  }

  return data;
}

function getEmpresaInitials(nome = '') {
  const parts = String(nome || 'Loja')
    .trim()
    .split(' ')
    .filter(Boolean);

  if (!parts.length) return 'LJ';

  const first = parts[0]?.[0] || 'L';
  const second = parts[1]?.[0] || parts[0]?.[1] || 'J';

  return `${first}${second}`.toUpperCase();
}

function getCanalUnidadeId(canal = {}) {
  return String(
    canal.unidadeId?._id ||
      canal.unidadeId ||
      canal.unidade?._id ||
      canal.unidade ||
      ''
  );
}

function getCanalEmpresaOperacionalId(canal = {}) {
  return String(
    canal.empresaId?._id ||
      canal.empresaId ||
      canal.empresa?._id ||
      canal.empresa ||
      ''
  );
}

function encontrarCanalDaEmpresa(canais = [], empresaId = '') {
  const id = String(empresaId || '');

  return canais.find((canal) => {
    return getCanalUnidadeId(canal) === id || getCanalEmpresaOperacionalId(canal) === id;
  });
}

function getChannelInitialForm(empresa = null) {
  return {
    empresaId: empresa?._id || '',
    nome: empresa?.nome ? `WhatsApp ${empresa.nome}` : '',
    numero: empresa?.whatsapp || empresa?.telefone || '',
    principal: true
  };
}

function getQueryParam(name) {
  try {
    return new URLSearchParams(window.location.search).get(name);
  } catch {
    return null;
  }
}

function limparQueryCanais() {
  try {
    const url = new URL(window.location.href);
    url.searchParams.delete('abrirCanal');
    url.searchParams.delete('empresaId');

    window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
  } catch {
    // ignora
  }
}


function getCanalId(canal = {}) {
  return String(canal?._id || canal?.id || canal?.canalWhatsappId || canal?.canalId || '');
}

function getCanalEmpresaId(canal = {}, empresa = {}) {
  return String(
    canal?.empresaId?._id ||
      canal?.empresaId ||
      empresa?._id ||
      ''
  );
}

function getCanalRuntime(canal = {}) {
  const runtime = canal?.runtime || {};
  const rawStatus = String(runtime.status || canal.status || '').toUpperCase();
  const connected = Boolean(runtime.connected || rawStatus === 'CONNECTED' || rawStatus === 'isLogged');
  const status = connected ? 'CONNECTED' : rawStatus || 'DISCONNECTED';

  return {
    connected,
    status,
    qrCode: runtime.qrCode || canal.qrCode || canal.lastQrCode || '',
    isInitializing: Boolean(runtime.isInitializing || status === 'INITIALIZING'),
    sessionName: runtime.sessionName || canal.sessionName || '',
    lastStatusAt: runtime.lastStatusAt || canal.ultimoStatusEm || canal.lastStatusAt || null
  };
}

function getCanalStatusMeta(canal = {}) {
  const runtime = getCanalRuntime(canal);
  const status = runtime.status;

  if (runtime.connected || status === 'CONNECTED') {
    return {
      label: 'Conectado',
      tone: 'success',
      description: 'Canal pronto para enviar mensagens.'
    };
  }

  if (status === 'QRCODE') {
    return {
      label: 'Aguardando QR',
      tone: 'warning',
      description: 'Escaneie o QR Code para conectar.'
    };
  }

  if (status === 'INITIALIZING' || status === 'LOADING' || status === 'DISCONNECTING') {
    return {
      label: status === 'DISCONNECTING' ? 'Desconectando' : 'Conectando',
      tone: 'warning',
      description: 'Aguarde alguns segundos.'
    };
  }

  if (status === 'ERROR') {
    return {
      label: 'Erro',
      tone: 'danger',
      description: 'Tente conectar novamente.'
    };
  }

  return {
    label: 'Desconectado',
    tone: 'neutral',
    description: 'Conecte este canal para exibir o QR Code.'
  };
}

function extrairQrCodeResponse(data = {}) {
  return (
    data.qrCode ||
    data.qrcode ||
    data.qr ||
    data.code ||
    data.base64Qr ||
    data.base64QRCode ||
    data.urlCode ||
    data.qr_code ||
    data.qr_url ||
    data.data?.qrCode ||
    data.data?.qrcode ||
    data.data?.qr ||
    data.data?.code ||
    data.data?.urlCode ||
    data.data?.qr_code ||
    data.data?.qr_url ||
    ''
  );
}

function pareceImagemBase64(qr = '') {
  const value = String(qr || '').trim();

  /*
    Não use tamanho para decidir se é imagem.
    O urlCode/raw QR do WhatsApp também pode ser grande.
    Se tratar raw QR como imagem base64, o <img> quebra e o QR não aparece.
  */
  return (
    value.startsWith('iVBOR') ||      // PNG base64
    value.startsWith('/9j/') ||       // JPG/JPEG base64
    value.startsWith('R0lGOD') ||     // GIF base64
    value.startsWith('PHN2Zy')        // SVG base64
  );
}

function formatQrCodeSrc(qrCode = '') {
  const qr = String(qrCode || '').trim();

  if (!qr) return '';
  if (qr.startsWith('data:image')) return qr;
  if (qr.startsWith('http://') || qr.startsWith('https://')) return qr;

  /*
    Se vier base64 de imagem, renderiza como <img>.
    Se vier urlCode/string raw do WhatsApp, não força como imagem,
    porque isso quebra o src. Nesse caso renderizamos com QRCodeCanvas.
  */
  if (pareceImagemBase64(qr)) {
    return `data:image/png;base64,${qr}`;
  }

  return '';
}

function getQrCodeRawValue(qrCode = '') {
  const qr = String(qrCode || '').trim();

  if (!qr) return '';
  if (formatQrCodeSrc(qr)) return '';

  return qr;
}

function getCanalRoute(canalOuId, action = '') {
  const canalWhatsappId = typeof canalOuId === 'object'
    ? getCanalId(canalOuId)
    : String(canalOuId || '');

  if (!canalWhatsappId) return '';

  const base = `/api/whatsapp/canais/${canalWhatsappId}`;
  return action ? `${base}/${action}` : base;
}

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

function formatarHoraCurta(valor) {
  if (!valor) return '';

  try {
    const data = new Date(valor);

    if (Number.isNaN(data.getTime())) return '';

    return data.toLocaleTimeString('pt-BR', {
      hour: '2-digit',
      minute: '2-digit'
    });
  } catch {
    return '';
  }
}

function canalEstaTentandoConectar(connection = {}) {
  const status = String(connection?.status || '').toUpperCase();

  return Boolean(
    connection?.loading ||
      connection?.checking ||
      connection?.connectLock ||
      ['INITIALIZING', 'LOADING', 'QRCODE'].includes(status)
  );
}

function statusEhDesconectado(status = '') {
  return ['DISCONNECTED', 'NO_CHANNEL', ''].includes(String(status || '').toUpperCase());
}

function montarPayloadCanal(canal = {}, empresa = {}) {
  const canalWhatsappId = getCanalId(canal);
  const unidadeId = getCanalUnidadeId(canal) || empresa?._id || '';
  const empresaId = getCanalEmpresaId(canal, empresa);

  return {
    empresaId,
    unidadeId,
    canalWhatsappId,
    canalId: canalWhatsappId
  };
}

export default function Empresas() {
  const [empresas, setEmpresas] = useState([]);
  const [resumoPlano, setResumoPlano] = useState({
    planoCodigo: 'start',
    planoNome: 'Start',
    limiteEmpresas: 1,
    quantidadeEmpresas: 1,
    totalEmpresasAtivas: 0,
    disponiveis: 0,
    podeCriar: false,
    checkoutSessionId: null
  });

  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const [showForm, setShowForm] = useState(false);
  const [editId, setEditId] = useState(null);

  const [formData, setFormData] = useState(initialForm);
  const [logoFile, setLogoFile] = useState(null);
  const [logoPreview, setLogoPreview] = useState(null);
  const [certificadoA1File, setCertificadoA1File] = useState(null);

  const [toast, setToast] = useState(null);
  const [canalAutoOpenHandled, setCanalAutoOpenHandled] = useState(false);

  const [canais, setCanais] = useState([]);
  const [loadingCanais, setLoadingCanais] = useState(false);
  const [creatingChannel, setCreatingChannel] = useState(false);
  const [channelModal, setChannelModal] = useState({
    open: false,
    empresa: null
  });
  const [channelForm, setChannelForm] = useState(getChannelInitialForm());
  const [channelConnection, setChannelConnection] = useState({
    canal: null,
    status: 'DISCONNECTED',
    connected: false,
    qrCode: '',
    sessionName: '',
    startedAt: null,
    lastStatusAt: null,
    connectLock: false,
    actionToken: null,
    loading: false,
    checking: false,
    error: ''
  });

  const empresasAtivas = useMemo(() => {
    return empresas.filter((empresa) => empresa.ativo !== false);
  }, [empresas]);

  const editando = Boolean(editId);

  const canalAtualModal = useMemo(() => {
    if (!channelModal.open || !channelModal.empresa?._id) return null;
    return encontrarCanalDaEmpresa(canais, channelModal.empresa._id) || null;
  }, [channelModal.open, channelModal.empresa, canais]);

  const pollingCanalId = getCanalId(channelConnection.canal || canalAtualModal || {});
  const pollingEmpresaId = getCanalEmpresaId(channelConnection.canal || canalAtualModal || {}, channelModal.empresa || {});
  const pollingUnidadeId = getCanalUnidadeId(channelConnection.canal || canalAtualModal || {}) || channelModal.empresa?._id || '';

  function showToast(type, message) {
    setToast({ type, message });
    setTimeout(() => setToast(null), 3200);
  }

  async function fetchEmpresas() {
    setLoading(true);

    try {
      const response = await api.get('/empresas', {
        params: {
          comResumo: true
        }
      });

      const parsed = normalizarRespostaEmpresas(response.data);

      setEmpresas(parsed.empresas);
      setResumoPlano(parsed.resumoPlano);
    } catch (error) {
      console.error(error);
      showToast('error', error.response?.data?.error || 'Erro ao carregar empresas.');
    } finally {
      setLoading(false);
    }
  }

  async function fetchCanais() {
    setLoadingCanais(true);

    try {
      const response = await api.get('/api/whatsapp/canais');
      const lista = Array.isArray(response.data?.canais) ? response.data.canais : [];
      setCanais(lista);
      return lista;
    } catch (error) {
      console.warn('[Empresas] Não foi possível carregar canais:', error);
      setCanais([]);
      return [];
    } finally {
      setLoadingCanais(false);
    }
  }

  useEffect(() => {
    fetchEmpresas();
    fetchCanais();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (canalAutoOpenHandled) return;
    if (loading || loadingCanais) return;
    if (!empresas.length) return;

    const deveAbrirCanal = getQueryParam('abrirCanal') === '1';

    if (!deveAbrirCanal) return;

    const empresaAlvo = escolherEmpresaParaCanal(empresas, canais);

    setCanalAutoOpenHandled(true);
    limparQueryCanais();

    if (!empresaAlvo) {
      showToast('error', 'Nenhuma empresa disponível para criar canal.');
      return;
    }

    openChannelModal(empresaAlvo);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [canalAutoOpenHandled, loading, loadingCanais, empresas, canais]);

  useEffect(() => {
    if (!channelModal.open) return;
    if (!canalAtualModal) return;

    const runtime = getCanalRuntime(canalAtualModal);

        setChannelConnection((prev) => {
      const mesmoCanal = getCanalId(prev.canal) === getCanalId(canalAtualModal);

      /*
        Se o usuário acabou de clicar em conectar, não deixa a lista de canais
        do banco sobrescrever o estado local com DISCONNECTED antigo.
      */
      if (mesmoCanal && canalEstaTentandoConectar(prev)) {
        return {
          ...prev,
          canal: prev.canal || canalAtualModal,
          sessionName: prev.sessionName || runtime.sessionName || '',
          lastStatusAt: prev.lastStatusAt || runtime.lastStatusAt || null
        };
      }

      return {
        canal: canalAtualModal,
        status: runtime.status,
        connected: runtime.connected,
        qrCode: runtime.qrCode || prev.qrCode || '',
        sessionName: runtime.sessionName,
        startedAt: runtime.lastStatusAt || null,
        lastStatusAt: runtime.lastStatusAt || null,
        connectLock: false,
        actionToken: null,
        loading: false,
        checking: false,
        error: ''
      };
    });
  }, [channelModal.open, canalAtualModal]);

  useEffect(() => {
    if (!channelModal.open) return;
    if (!pollingCanalId || !pollingEmpresaId) return;
    if (channelConnection.connected) return;

    let ativo = true;

    const consultarStatus = async () => {
      try {
        const response = await api.get(getCanalRoute(pollingCanalId, 'status'));

        if (!ativo) return;

        const data = response.data || {};
        const status = String(data.status || '').toUpperCase();
        const connected = Boolean(data.connected || status === 'CONNECTED');
        const qrCode = extrairQrCodeResponse(data);

        setChannelConnection((prev) => {
          const tentativaAtiva = canalEstaTentandoConectar(prev);
          const statusRecebido = connected ? 'CONNECTED' : status || 'DISCONNECTED';
          const recebeuDesconectadoDuranteTentativa = tentativaAtiva && statusEhDesconectado(statusRecebido);

          /*
            Durante o clique em conectar, o backend pode responder DISCONNECTED por
            alguns segundos até o client WPPConnect existir em memória.
            Não derruba o loader/local state nessa janela.
          */
          if (recebeuDesconectadoDuranteTentativa) {
            return {
              ...prev,
              canal: prev.canal || canalAtualModal,
              status: prev.status || 'INITIALIZING',
              connected: false,
              qrCode: prev.qrCode || '',
              sessionName: data.sessionName || prev.sessionName || '',
              startedAt: prev.startedAt || data.lastStatusAt || new Date().toISOString(),
              lastStatusAt: data.lastStatusAt || new Date().toISOString(),
              checking: true,
              loading: true,
              error: ''
            };
          }

          return {
            ...prev,
            canal: prev.canal || canalAtualModal,
            status: statusRecebido,
            connected,
            qrCode: qrCode || prev.qrCode || '',
            sessionName: data.sessionName || prev.sessionName || '',
            startedAt: prev.startedAt || data.lastStatusAt || new Date().toISOString(),
            lastStatusAt: data.lastStatusAt || new Date().toISOString(),
            connectLock: connected || qrCode || statusRecebido === 'QRCODE' ? false : prev.connectLock,
            actionToken: connected || qrCode || statusRecebido === 'QRCODE' ? null : prev.actionToken,
            checking: false,
            loading: false,
            error: ''
          };
        });

        if (connected) {
          fetchCanais();
        }
      } catch (error) {
        if (!ativo) return;

        setChannelConnection((prev) => ({
          ...prev,
          checking: false,
          loading: false,
          error: error.response?.data?.message || error.response?.data?.error || 'Erro ao consultar status do canal.'
        }));
      }
    };

    consultarStatus();

    const interval = setInterval(consultarStatus, 2500);

    return () => {
      ativo = false;
      clearInterval(interval);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [channelModal.open, pollingCanalId, pollingEmpresaId, pollingUnidadeId, channelConnection.connected]);

  useEffect(() => {
    return () => {
      if (logoPreview && logoPreview.startsWith('blob:')) {
        URL.revokeObjectURL(logoPreview);
      }
    };
  }, [logoPreview]);

  function handleUpgradePlan() {
    /*
      Rota futura. Quando tiver a tela de upgrade, é só trocar aqui.
      Exemplo:
      window.location.href = '/planos';
    */
    showToast('info', 'Upgrade de plano em breve. Esse botão já está preparado para a próxima etapa.');
  }

  function openChannelModal(empresa) {
    const canal = encontrarCanalDaEmpresa(canais, empresa?._id);
    const runtime = getCanalRuntime(canal || {});

    setChannelModal({
      open: true,
      empresa
    });

    setChannelForm(canal ? {
      empresaId: empresa?._id || '',
      nome: canal.nome || `WhatsApp ${empresa?.nome || ''}`,
      numero: formatarTelefone(canal.numero || canal.whatsapp || canal.telefone || empresa?.whatsapp || empresa?.telefone || ''),
      principal: canal.principal !== false
    } : getChannelInitialForm(empresa));

    setChannelConnection({
      canal: canal || null,
      status: runtime.status,
      connected: runtime.connected,
      qrCode: runtime.qrCode || '',
      sessionName: runtime.sessionName || '',
      startedAt: runtime.lastStatusAt || null,
      lastStatusAt: runtime.lastStatusAt || null,
      connectLock: false,
      actionToken: null,
      loading: false,
      checking: false,
      error: ''
    });
  }

  function escolherEmpresaParaCanal(listaEmpresas = empresas, listaCanais = canais) {
    const empresaIdQuery = getQueryParam('empresaId');

    if (empresaIdQuery) {
      const encontrada = listaEmpresas.find((empresa) => String(empresa._id) === String(empresaIdQuery));

      if (encontrada) return encontrada;
    }

    const empresasAtivasLista = listaEmpresas.filter((empresa) => empresa.ativo !== false);

    return (
      empresasAtivasLista.find((empresa) => !encontrarCanalDaEmpresa(listaCanais, empresa._id)) ||
      empresasAtivasLista[0] ||
      listaEmpresas[0] ||
      null
    );
  }

  function closeChannelModal() {
    if (creatingChannel) return;

    setChannelModal({
      open: false,
      empresa: null
    });

    setChannelForm(getChannelInitialForm());
    setChannelConnection({
      canal: null,
      status: 'DISCONNECTED',
      connected: false,
      qrCode: '',
      sessionName: '',
      startedAt: null,
      lastStatusAt: null,
      connectLock: false,
      actionToken: null,
      loading: false,
      checking: false,
      error: ''
    });
  }

  function handleChannelInputChange(e) {
    const { name, value, type, checked } = e.target;

    let nextValue = type === 'checkbox' ? checked : value;

    if (name === 'numero') {
      nextValue = formatarTelefone(value);
    }

    setChannelForm((prev) => ({
      ...prev,
      [name]: nextValue
    }));
  }

  async function handleCreateChannel(e) {
    e.preventDefault();

    if (!channelModal.empresa?._id) {
      showToast('error', 'Empresa não identificada para criar o canal.');
      return;
    }

    if (!String(channelForm.nome || '').trim()) {
      showToast('error', 'Informe o nome do canal.');
      return;
    }

    setCreatingChannel(true);

    try {
      const response = await api.post('/api/whatsapp/canais', {
        empresaId: channelModal.empresa._id,
        unidadeId: channelModal.empresa._id,
        nome: channelForm.nome,
        numero: String(channelForm.numero || '').replace(/\D/g, ''),
        principal: Boolean(channelForm.principal),
        ativo: true
      });

      const lista = await fetchCanais();
      const canalResposta = response.data?.canal || response.data?.channel || response.data?.data || response.data;
      const canalCriado =
        encontrarCanalDaEmpresa(lista, channelModal.empresa._id) ||
        (canalResposta && getCanalId(canalResposta) ? canalResposta : null);

      if (canalCriado) {
        const runtime = getCanalRuntime(canalCriado);

        setChannelConnection({
          canal: canalCriado,
          status: runtime.status,
          connected: runtime.connected,
          qrCode: runtime.qrCode || '',
          sessionName: runtime.sessionName || '',
          startedAt: runtime.lastStatusAt || new Date().toISOString(),
          lastStatusAt: runtime.lastStatusAt || null,
          connectLock: false,
          actionToken: null,
          loading: false,
          checking: false,
          error: ''
        });
      }

      showToast('success', 'Canal criado. Agora clique em conectar este canal para exibir o QR Code.');
    } catch (error) {
      showToast(
        'error',
        error.response?.data?.message ||
          error.response?.data?.error ||
          'Erro ao criar canal de comunicação.'
      );
    } finally {
      setCreatingChannel(false);
    }
  }


  async function consultarStatusCanal(canal, empresa = channelModal.empresa, options = {}) {
    const canalWhatsappId = getCanalId(canal);

    if (!canalWhatsappId) return null;

    const { silent = true } = options;

    if (!silent) {
      setChannelConnection((prev) => ({
        ...prev,
        checking: true,
        error: ''
      }));
    }

    try {
      const response = await api.get(getCanalRoute(canalWhatsappId, 'status'));

      const data = response.data || {};
      const status = String(data.status || '').toUpperCase();
      const connected = Boolean(data.connected || status === 'CONNECTED');
      const qrCode = extrairQrCodeResponse(data);

      setChannelConnection((prev) => {
        const tentativaAtiva = canalEstaTentandoConectar(prev);
        const statusRecebido = connected ? 'CONNECTED' : status || 'DISCONNECTED';
        const recebeuDesconectadoDuranteTentativa = tentativaAtiva && statusEhDesconectado(statusRecebido);

        if (recebeuDesconectadoDuranteTentativa) {
          return {
            ...prev,
            canal,
            status: prev.status || 'INITIALIZING',
            connected: false,
            qrCode: prev.qrCode || '',
            sessionName: data.sessionName || prev.sessionName || '',
            checking: true,
            loading: true,
            error: ''
          };
        }

        return {
          ...prev,
          canal,
          status: statusRecebido,
          connected,
          qrCode: qrCode || prev.qrCode || '',
          sessionName: data.sessionName || prev.sessionName || '',
          connectLock: connected || qrCode || statusRecebido === 'QRCODE' ? false : prev.connectLock,
          actionToken: connected || qrCode || statusRecebido === 'QRCODE' ? null : prev.actionToken,
          checking: false,
          loading: false,
          error: ''
        };
      });

      if (connected) {
        fetchCanais();
      }

      return {
        ...data,
        status,
        connected,
        qrCode
      };
    } catch (error) {
      if (!silent) {
        setChannelConnection((prev) => ({
          ...prev,
          checking: false,
          loading: false,
          error: error.response?.data?.message || error.response?.data?.error || 'Erro ao consultar status do canal.'
        }));
      }

      return null;
    }
  }

  async function aguardarQrCodeDoCanal(canal, empresa = channelModal.empresa) {
    /*
      O /connect só inicia o navegador.
      O QR Code nasce alguns segundos depois no catchQR do backend.
      Por isso fazemos uma consulta curta e rápida logo após conectar,
      sem esperar o polling de 2.5s.
    */
    const tentativas = 28;

    for (let tentativa = 0; tentativa < tentativas; tentativa += 1) {
      await sleep(tentativa === 0 ? 450 : 900);

      const statusAtual = await consultarStatusCanal(canal, empresa, {
        silent: true
      });

      if (!statusAtual) continue;

      if (statusAtual.connected || statusAtual.status === 'CONNECTED') {
        return statusAtual;
      }

      if (statusAtual.qrCode || statusAtual.status === 'QRCODE') {
        return statusAtual;
      }
    }

    return null;
  }

  async function handleConnectChannel(canal, empresa = channelModal.empresa) {
    const canalWhatsappId = getCanalId(canal);

    if (!canalWhatsappId) {
      showToast('error', 'Crie o canal antes de conectar.');
      return;
    }

    const payload = montarPayloadCanal(canal, empresa || {});
    const actionToken = `${canalWhatsappId}-${Date.now()}`;

    setChannelConnection((prev) => ({
      ...prev,
      canal,
      loading: true,
      checking: true,
      connectLock: true,
      actionToken,
      status: 'INITIALIZING',
      connected: false,
      error: '',
      startedAt: new Date().toISOString(),
      lastStatusAt: new Date().toISOString(),
      qrCode: prev.qrCode || ''
    }));

    try {
      const response = await api.post(getCanalRoute(canalWhatsappId, 'connect'), payload);
      const data = response.data || {};
      const status = String(data.status || '').toUpperCase();
      const connected = Boolean(data.connected || status === 'CONNECTED' || data.message === 'WhatsApp já conectado.');
      const qrCode = extrairQrCodeResponse(data);

      setChannelConnection((prev) => ({
        ...prev,
        canal,
        status: connected ? 'CONNECTED' : status || 'INITIALIZING',
        connected,
        qrCode: qrCode || prev.qrCode || '',
        sessionName: data.sessionName || prev.sessionName || '',
        startedAt: prev.startedAt || new Date().toISOString(),
        lastStatusAt: data.lastStatusAt || new Date().toISOString(),
        connectLock: !connected && !qrCode,
        actionToken: !connected && !qrCode ? actionToken : null,
        loading: !connected && !qrCode,
        checking: !connected && !qrCode,
        error: ''
      }));

      const statusAposConectar = connected || qrCode
        ? { connected, status: connected ? 'CONNECTED' : status || 'QRCODE', qrCode }
        : await aguardarQrCodeDoCanal(canal, empresa);

      /*
        Só atualiza a lista depois que já temos QR/CONNECTED ou depois da janela
        curta de espera. Antes disso, o canal vindo do banco pode estar velho e
        voltar visualmente para DISCONNECTED.
      */
      await fetchCanais();

      setChannelConnection((prev) => {
        if (prev.actionToken && prev.actionToken !== actionToken) {
          return prev;
        }

        if (statusAposConectar?.connected || statusAposConectar?.status === 'CONNECTED') {
          return {
            ...prev,
            canal,
            status: 'CONNECTED',
            connected: true,
            qrCode: '',
            connectLock: false,
            actionToken: null,
            loading: false,
            checking: false,
            error: ''
          };
        }

        if (statusAposConectar?.qrCode || statusAposConectar?.status === 'QRCODE') {
          return {
            ...prev,
            canal,
            status: 'QRCODE',
            connected: false,
            qrCode: statusAposConectar.qrCode || prev.qrCode || '',
            connectLock: false,
            actionToken: null,
            loading: false,
            checking: false,
            error: ''
          };
        }

        /*
          Se ainda não veio QR, não volta para desconectado.
          Mantém visualmente como aguardando para o usuário poder ver o loader
          e decidir parar a conexão.
        */
        return {
          ...prev,
          canal,
          status: prev.status || 'INITIALIZING',
          connected: false,
          connectLock: true,
          actionToken,
          loading: true,
          checking: true,
          error: ''
        };
      });

      if (statusAposConectar?.qrCode || statusAposConectar?.status === 'QRCODE') {
        showToast('success', 'QR Code gerado. Escaneie para conectar o canal.');
      } else if (statusAposConectar?.connected || connected) {
        showToast('success', 'Canal já está conectado.');
      } else {
        showToast('info', 'Conexão iniciada. Ainda aguardando o QR Code...');
      }
    } catch (error) {
      setChannelConnection((prev) => ({
        ...prev,
        loading: false,
        checking: false,
        connectLock: false,
        actionToken: null,
        status: 'ERROR',
        error: error.response?.data?.message || error.response?.data?.error || error.message || 'Erro ao conectar canal.'
      }));

      showToast('error', error.response?.data?.message || error.response?.data?.error || 'Erro ao conectar canal.');
    }
  }

  async function handleDisconnectChannel(canal, empresa = channelModal.empresa) {
    const canalWhatsappId = getCanalId(canal);

    if (!canalWhatsappId) {
      showToast('error', 'Canal não identificado para desconectar.');
      return;
    }

    if (!window.confirm('Deseja desconectar este canal de WhatsApp?')) {
      return;
    }

    const payload = montarPayloadCanal(canal, empresa || {});

    setChannelConnection((prev) => ({
      ...prev,
      canal,
      loading: true,
      checking: true,
      status: 'DISCONNECTING',
      connectLock: false,
      actionToken: null,
      error: ''
    }));

    try {
      await api.post(getCanalRoute(canalWhatsappId, 'disconnect'), payload);
      await fetchCanais();

      setChannelConnection((prev) => ({
        ...prev,
        canal,
        status: 'DISCONNECTED',
        connected: false,
        qrCode: '',
        connectLock: false,
        actionToken: null,
        startedAt: null,
        lastStatusAt: new Date().toISOString(),
        loading: false,
        checking: false,
        error: ''
      }));

      showToast('success', 'Canal desconectado com sucesso.');
    } catch (error) {
      setChannelConnection((prev) => ({
        ...prev,
        loading: false,
        checking: false,
        error: error.response?.data?.message || error.response?.data?.error || 'Erro ao desconectar canal.'
      }));

      showToast('error', error.response?.data?.message || error.response?.data?.error || 'Erro ao desconectar canal.');
    }
  }

  async function handleRefreshChannelStatus(canal, empresa = channelModal.empresa) {
    await consultarStatusCanal(canal, empresa, {
      silent: false
    });
  }

  function handleNewCompany() {
    if (!resumoPlano.podeCriar) {
      showToast(
        'error',
        `Seu plano permite até ${resumoPlano.limiteEmpresas} empresa(s). Faça upgrade para adicionar outra.`
      );
      return;
    }

    setEditId(null);
    setFormData(initialForm);
    setLogoFile(null);
    setLogoPreview(null);
    setCertificadoA1File(null);
    setShowForm(true);

    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  function resetForm() {
    setShowForm(false);
    setEditId(null);
    setFormData(initialForm);
    setLogoFile(null);
    setLogoPreview(null);
    setCertificadoA1File(null);
  }

  function handleInputChange(e) {
    const { name, value, type, checked } = e.target;

    let nextValue = type === 'checkbox' ? checked : value;

    if (name === 'cnpj') {
      nextValue = formatarCNPJ(value);
    }

    if (name === 'telefone' || name === 'whatsapp') {
      nextValue = formatarTelefone(value);
    }

    if (name === 'codigoLoja') {
      nextValue = String(value || '')
        .toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[^a-z0-9-_]/g, '');
    }

    setFormData((prev) => ({
      ...prev,
      [name]: nextValue
    }));
  }

  function handleLogoChange(e) {
    const file = e.target.files?.[0];

    if (!file) return;

    const allowed = ['image/jpeg', 'image/png', 'image/webp', 'image/svg+xml'];

    if (!allowed.includes(file.type)) {
      showToast('error', 'Envie uma logo em JPG, PNG, WEBP ou SVG.');
      return;
    }

    if (file.size > 3 * 1024 * 1024) {
      showToast('error', 'A logo deve ter no máximo 3MB.');
      return;
    }

    setLogoFile(file);

    const preview = URL.createObjectURL(file);
    setLogoPreview(preview);
  }

  function handleCertificadoA1Change(e) {
    const file = e.target.files?.[0];

    if (!file) return;

    if (!certificadoA1Valido(file)) {
      showToast('error', 'Envie um certificado A1 válido no formato .pfx ou .p12.');
      e.target.value = '';
      return;
    }

    if (file.size > 10 * 1024 * 1024) {
      showToast('error', 'O certificado A1 deve ter no máximo 10MB.');
      e.target.value = '';
      return;
    }

    setCertificadoA1File(file);

    setFormData((prev) => ({
      ...prev,
      certificadoA1Nome: file.name,
      certificadoA1Configurado: true
    }));
  }

  function handleEdit(emp) {
    setEditId(emp._id);

    setFormData({
      nome: emp.nome || '',
      codigoLoja: emp.codigoLoja || '',
      unidade: emp.unidade || '',
      cnpj: formatarCNPJ(emp.cnpj || ''),
      inscricaoEstadual: emp.inscricaoEstadual || '',
      endereco: emp.endereco || '',
      telefone: formatarTelefone(emp.telefone || ''),
      whatsapp: formatarTelefone(emp.whatsapp || ''),
      email: emp.email || '',
      linkAvaliacao: emp.linkAvaliacao || '',
      siteUrl: emp.siteUrl || '',
      instagram: emp.instagram || '',
      facebook: emp.facebook || '',
      corPrimaria: emp.corPrimaria || '#111318',
      corSecundaria: emp.corSecundaria || '#1a73e8',

      provedorFiscal: 'nfeio',
      ambienteNf:
        getFiscalValue(emp, 'ambiente', 'test') === 'production'
          ? 'producao'
          : 'homologacao',
      regimeTributario:
        getFiscalValue(emp, 'regimeTributario') ||
        getFiscalValue(emp, 'regime') ||
        'simples_nacional',
      nfeioCompanyId: getFiscalValue(emp, 'nfeioCompanyId'),
      nfeioApiKey: getFiscalValue(emp, 'nfeioApiKey'),
      cscId: getFiscalValue(emp, 'cscId'),
      cscCodigo: getFiscalValue(emp, 'cscCodigo'),
      certificadoSenha: '',
      certificadoA1Nome: getCertificadoA1Nome(emp),
      certificadoA1Configurado: empresaTemCertificadoA1(emp),
      statusAnalise: getFiscalValue(emp, 'statusAnalise', 'nao_enviado'),
      statusFiscal: getFiscalValue(emp, 'statusFiscal', getFiscalValue(emp, 'statusAnalise', 'nao_enviado')),
      emissaoLiberada: Boolean(getFiscalValue(emp, 'emissaoLiberada', false)),
      prontoParaAnalise: Boolean(getFiscalValue(emp, 'prontoParaAnalise', false)),
      analiseSolicitadaEm: getFiscalValue(emp, 'analiseSolicitadaEm', null),
      prazoAnaliseAte: getFiscalValue(emp, 'prazoAnaliseAte', null),
      analisadoEm: getFiscalValue(emp, 'analisadoEm', null),
      observacaoAnalise: getFiscalValue(emp, 'observacaoAnalise', ''),
      motivoPendencia: getFiscalValue(emp, 'motivoPendencia', ''),
      motivoReprovacao: getFiscalValue(emp, 'motivoReprovacao', ''),

      ativo: typeof emp.ativo === 'boolean' ? emp.ativo : true
    });

    setLogoFile(null);
    setLogoPreview(emp.logoUrl ? formatImageUrl(emp.logoUrl) : null);
    setCertificadoA1File(null);

    setShowForm(true);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  async function handleDeactivate(emp) {
    if (!window.confirm(`Deseja desativar a empresa "${emp.nome}"? Ela deixará de contar no limite de empresas ativas.`)) {
      return;
    }

    try {
      await api.patch(`/empresas/${emp._id}/desativar`);
      showToast('success', 'Empresa desativada com sucesso.');
      fetchEmpresas();
    } catch (error) {
      showToast('error', error.response?.data?.error || 'Erro ao desativar empresa.');
    }
  }

  async function handleDelete(emp) {
    if (!window.confirm(`Excluir definitivamente "${emp.nome}"? Essa ação não pode ser desfeita.`)) {
      return;
    }

    try {
      await api.delete(`/empresas/${emp._id}`);
      showToast('success', 'Empresa excluída com sucesso.');
      fetchEmpresas();
    } catch (error) {
      showToast('error', error.response?.data?.error || 'Erro ao excluir empresa.');
    }
  }

  async function handleSubmit(e) {
    e.preventDefault();

    if (!editando && !resumoPlano.podeCriar) {
      showToast(
        'error',
        `Limite atingido. Seu plano permite até ${resumoPlano.limiteEmpresas} empresa(s).`
      );
      return;
    }

    setSaving(true);

    try {
      const data = montarFormData(formData, logoFile, certificadoA1File);

      if (editId) {
        await api.put(`/empresas/${editId}`, data, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });

        showToast('success', 'Empresa atualizada com sucesso.');
      } else {
        await api.post('/empresas', data, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });

        showToast('success', 'Empresa criada com sucesso.');
      }

      resetForm();
      fetchEmpresas();
    } catch (error) {
      showToast('error', error.response?.data?.error || 'Erro ao salvar empresa.');
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="empresas-page">
      <GlobalStyles />

      <header className="page-head">
        <div className="page-head-left">
          <button type="button" onClick={() => window.history.back()} className="icon-button" title="Voltar">
            <Icons.ArrowLeft />
          </button>

          <div>
            <span className="eyebrow">Configurações</span>
            <h1>Empresas e lojas</h1>
            <p>Gerencie as empresas permitidas no seu plano.</p>
          </div>
        </div>

        <div className="page-actions">
          <button type="button" className="secondary-button" onClick={handleUpgradePlan}>
            Upgrade do plano
          </button>

          {!showForm && (
            <button
              type="button"
              className="primary-button"
              onClick={handleNewCompany}
              disabled={!resumoPlano.podeCriar}
              title={
                resumoPlano.podeCriar
                  ? 'Adicionar empresa'
                  : `Limite atingido: ${resumoPlano.limiteEmpresas} empresa(s)`
              }
            >
              <Icons.Plus />
              Adicionar empresa
            </button>
          )}
        </div>
      </header>

      <section className="plan-panel">
        <div className="plan-main">
          <span>Plano atual</span>
          <strong>{resumoPlano.planoNome || 'Start'}</strong>
          <p>
            Você pode manter até {resumoPlano.limiteEmpresas} empresa(s) ativa(s) neste plano.
          </p>
        </div>

        <div className="usage-box">
          <div className="usage-row">
            <span>Empresas ativas</span>
            <strong>
              {resumoPlano.totalEmpresasAtivas || empresasAtivas.length}/{resumoPlano.limiteEmpresas}
            </strong>
          </div>

          <div className="progress-track">
            <div
              className="progress-fill"
              style={{
                width: `${Math.min(
                  100,
                  ((resumoPlano.totalEmpresasAtivas || empresasAtivas.length) / Math.max(1, resumoPlano.limiteEmpresas)) * 100
                )}%`
              }}
            />
          </div>

          <div className="usage-foot">
            <span>
              {resumoPlano.disponiveis > 0
                ? `${resumoPlano.disponiveis} vaga(s) disponível(is)`
                : 'Limite atingido'}
            </span>

            {!resumoPlano.podeCriar && (
              <button type="button" onClick={handleUpgradePlan}>
                Aumentar limite
              </button>
            )}
          </div>
        </div>
      </section>

      <main className="page-content">
        {showForm ? (
          <CompanyForm
            editando={editando}
            formData={formData}
            logoPreview={logoPreview}
            certificadoA1File={certificadoA1File}
            saving={saving}
            onInputChange={handleInputChange}
            onLogoChange={handleLogoChange}
            onCertificadoA1Change={handleCertificadoA1Change}
            onSubmit={handleSubmit}
            onCancel={resetForm}
          />
        ) : (
          <CompanyList
            loading={loading}
            loadingCanais={loadingCanais}
            empresas={empresas}
            canais={canais}
            resumoPlano={resumoPlano}
            onNewCompany={handleNewCompany}
            onEdit={handleEdit}
            onCreateChannel={openChannelModal}
            onConnectChannel={handleConnectChannel}
            onDisconnectChannel={handleDisconnectChannel}
            onDeactivate={handleDeactivate}
            onDelete={handleDelete}
          />
        )}
      </main>

      {channelModal.open && (
        <ChannelModal
          empresa={channelModal.empresa}
          canal={canalAtualModal || channelConnection.canal}
          connection={channelConnection}
          form={channelForm}
          saving={creatingChannel}
          onChange={handleChannelInputChange}
          onClose={closeChannelModal}
          onSubmit={handleCreateChannel}
          onConnect={handleConnectChannel}
          onDisconnect={handleDisconnectChannel}
          onRefreshStatus={handleRefreshChannelStatus}
        />
      )}

      {toast && (
        <div className={`toast ${toast.type}`}>
          {toast.type === 'success' ? '✓' : toast.type === 'info' ? 'i' : '!'} {toast.message}
        </div>
      )}
    </div>
  );
}

function FiscalAnalysisCard({
  empresa,
  editando = false,
  saving = false
}) {
  const meta = getFiscalStatusMeta(empresa);
  const status = getFiscalStatus(empresa);
  return (
    <div className={`fiscal-analysis-card ${meta.tone}`}>
      <div className="fiscal-analysis-icon">
        {status === 'aprovado' ? <Icons.Check /> : status === 'em_analise' ? <Icons.Clock /> : <Icons.Alert />}
      </div>

      <div className="fiscal-analysis-copy">
        <span>Status fiscal</span>
        <strong>{meta.title}</strong>
        <p>{getFiscalMensagemPrincipal(empresa)}</p>

        {status === 'em_analise' && (
          <small>Enquanto estiver em análise, a emissão de NFC-e fica bloqueada.</small>
        )}

        {status === 'aprovado' && (
          <small>A empresa está apta para emitir notas fiscais pela OS.</small>
        )}
      </div>
    </div>
  );
}

function FiscalStatusBadge({ empresa }) {
  const meta = getFiscalStatusMeta(empresa);
  const status = getFiscalStatus(empresa);

  return (
    <span className={`fiscal-status-badge ${meta.tone}`}>
      {status === 'aprovado' ? <Icons.Check /> : status === 'em_analise' ? <Icons.Clock /> : <Icons.Alert />}
      {meta.label}
    </span>
  );
}

function CompanyForm({
  editando,
  formData,
  logoPreview,
  certificadoA1File,
  saving,
  onInputChange,
  onLogoChange,
  onCertificadoA1Change,
  onSubmit,
  onCancel
}) {
  return (
    <section className="form-card">
      <div className="form-title">
        <div>
          <h2>{editando ? 'Editar empresa' : 'Nova empresa'}</h2>
          <p>
            Preencha os dados fiscais. Ao salvar, a configuração entra automaticamente em análise.
          </p>
        </div>

        <button type="button" className="secondary-button compact" onClick={onCancel}>
          Cancelar
        </button>
      </div>

      <form onSubmit={onSubmit}>
        <div className="form-section">
          <aside>
            <h3>Logo</h3>
            <p>Usada nos documentos, painel e telas da loja.</p>
          </aside>

          <div>
            <label className="logo-uploader">
              {logoPreview ? (
                <img src={logoPreview} alt="Logo da empresa" />
              ) : (
                <div>
                  <Icons.Upload />
                  <span>Enviar logo</span>
                  <small>JPG, PNG, WEBP ou SVG</small>
                </div>
              )}

              <input type="file" accept="image/jpeg,image/png,image/webp,image/svg+xml" onChange={onLogoChange} hidden />
            </label>
          </div>
        </div>

        <div className="form-section">
          <aside>
            <h3>Dados principais</h3>
            <p>Identificação da loja dentro da Lumix.</p>
          </aside>

          <div className="form-grid">
            <Field label="Nome fantasia" required>
              <input
                required
                name="nome"
                value={formData.nome}
                onChange={onInputChange}
                placeholder="Ex: Óticas Lumix Centro"
              />
            </Field>

            <Field label="Código da loja" required helper="Use algo simples: matriz, loja-01, centro">
              <input
                required
                name="codigoLoja"
                value={formData.codigoLoja}
                onChange={onInputChange}
                placeholder="loja-01"
              />
            </Field>

            <Field label="Unidade / região">
              <input
                name="unidade"
                value={formData.unidade}
                onChange={onInputChange}
                placeholder="Ex: Centro"
              />
            </Field>

            <Field label="CNPJ">
              <input
                name="cnpj"
                value={formData.cnpj}
                onChange={onInputChange}
                placeholder="00.000.000/0001-00"
              />
            </Field>

            <Field label="Inscrição estadual">
              <input
                name="inscricaoEstadual"
                value={formData.inscricaoEstadual}
                onChange={onInputChange}
                placeholder="Número ou Isento"
              />
            </Field>

            <Field label="Status">
              <label className="switch-line">
                <input
                  type="checkbox"
                  name="ativo"
                  checked={formData.ativo}
                  onChange={onInputChange}
                />
                <span />
                {formData.ativo ? 'Empresa ativa' : 'Empresa pausada'}
              </label>
            </Field>

            <Field label="Endereço" full>
              <input
                name="endereco"
                value={formData.endereco}
                onChange={onInputChange}
                placeholder="Rua, número, bairro - cidade/UF"
              />
            </Field>
          </div>
        </div>

        <div className="form-section">
          <aside>
            <h3>Contato</h3>
            <p>Dados usados em documentos e relacionamento.</p>
          </aside>

          <div className="form-grid">
            <Field label="WhatsApp">
              <input
                name="whatsapp"
                value={formData.whatsapp}
                onChange={onInputChange}
                placeholder="(00) 00000-0000"
              />
            </Field>

            <Field label="Telefone">
              <input
                name="telefone"
                value={formData.telefone}
                onChange={onInputChange}
                placeholder="(00) 0000-0000"
              />
            </Field>

            <Field label="E-mail">
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={onInputChange}
                placeholder="loja@empresa.com"
              />
            </Field>

            <Field label="Link de avaliação">
              <input
                name="linkAvaliacao"
                value={formData.linkAvaliacao}
                onChange={onInputChange}
                placeholder="Link do Google Avaliações"
              />
            </Field>

            <Field label="Site">
              <input
                name="siteUrl"
                value={formData.siteUrl}
                onChange={onInputChange}
                placeholder="https://..."
              />
            </Field>

            <Field label="Instagram">
              <input
                name="instagram"
                value={formData.instagram}
                onChange={onInputChange}
                placeholder="@suaotica"
              />
            </Field>
          </div>
        </div>

        <div className="form-section">
          <aside>
            <h3>Identidade</h3>
            <p>Cores usadas em documentos e personalização.</p>
          </aside>

          <div className="form-grid">
            <Field label="Cor primária">
              <div className="color-field">
                <input
                  type="color"
                  name="corPrimaria"
                  value={formData.corPrimaria}
                  onChange={onInputChange}
                />
                <input
                  name="corPrimaria"
                  value={formData.corPrimaria}
                  onChange={onInputChange}
                />
              </div>
            </Field>

            <Field label="Cor secundária">
              <div className="color-field">
                <input
                  type="color"
                  name="corSecundaria"
                  value={formData.corSecundaria}
                  onChange={onInputChange}
                />
                <input
                  name="corSecundaria"
                  value={formData.corSecundaria}
                  onChange={onInputChange}
                />
              </div>
            </Field>
          </div>
        </div>

        <details className="advanced-section">
          <summary>
            <span>Configuração fiscal</span>
            <small>NFe.io, regime tributário, CSC e A1</small>
          </summary>

          <div className="advanced-grid">
            <FiscalAnalysisCard
              empresa={formData}
              editando={editando}
              saving={saving}
            />

            <div className="provider-fixed-card">
              <span>Provedor fiscal</span>
              <strong>NFe.io</strong>
              <small>Integração padrão para emissão fiscal da Lumix.</small>
            </div>

            <Field label="Ambiente">
              <select name="ambienteNf" value={formData.ambienteNf} onChange={onInputChange}>
                <option value="homologacao">Homologação</option>
                <option value="producao">Produção</option>
              </select>
            </Field>

            <Field label="Regime tributário">
              <select name="regimeTributario" value={formData.regimeTributario} onChange={onInputChange}>
                {REGIMES_TRIBUTARIOS.map((regime) => (
                  <option key={regime.value} value={regime.value}>
                    {regime.label}
                  </option>
                ))}
              </select>
            </Field>

            <LockedField
              label="NFe.io Company ID"
              value={formData.nfeioCompanyId}
              placeholder="Configurado pela Lumix"
            />

            <LockedField
              label="NFe.io API Key"
              value={formData.nfeioApiKey ? '••••••••••••••••••••••••' : ''}
              placeholder="Configurada pela Lumix"
            />

            <Field label="CSC ID">
              <input
                name="cscId"
                value={formData.cscId}
                onChange={onInputChange}
                placeholder="Ex: 1"
              />
            </Field>

            <Field label="Código CSC">
              <input
                name="cscCodigo"
                value={formData.cscCodigo}
                onChange={onInputChange}
                placeholder="Código de segurança do contribuinte"
              />
            </Field>

            <div className="certificate-card">
              <div className="certificate-head">
                <div>
                  <strong>Certificado A1</strong>
                  <span>Arquivo .pfx ou .p12 usado para emissão de NFC-e.</span>
                </div>

                <span className={`certificate-status ${formData.certificadoA1Configurado ? 'ok' : ''}`}>
                  {formData.certificadoA1Configurado ? 'Configurado' : 'Pendente'}
                </span>
              </div>

              <label className="certificate-uploader">
                <Icons.Upload />
                <div>
                  <strong>
                    {certificadoA1File?.name ||
                      formData.certificadoA1Nome ||
                      'Enviar certificado A1'}
                  </strong>
                  <span>.pfx ou .p12 · até 10MB</span>
                </div>

                <input
                  type="file"
                  accept=".pfx,.p12,application/x-pkcs12,application/octet-stream"
                  onChange={onCertificadoA1Change}
                  hidden
                />
              </label>

              <Field label="Senha do certificado">
                <input
                  type="password"
                  name="certificadoSenha"
                  value={formData.certificadoSenha}
                  onChange={onInputChange}
                  placeholder={formData.certificadoA1Configurado ? 'Digite somente se for trocar/atualizar' : 'Senha do A1'}
                  autoComplete="new-password"
                />
              </Field>

              <p className="certificate-note">
                A senha não é exibida depois de salva. Para trocar o certificado, envie um novo arquivo e informe a senha novamente.
              </p>
            </div>
          </div>
        </details>

        <div className="form-actions">
          <button type="button" className="secondary-button" onClick={onCancel}>
            Cancelar
          </button>

          <button type="submit" className="primary-button" disabled={saving}>
            {saving ? 'Salvando...' : editando ? 'Salvar alterações' : 'Criar empresa'}
          </button>
        </div>
      </form>
    </section>
  );
}

function Field({ label, helper, required, full, children }) {
  return (
    <label className={`field ${full ? 'full' : ''}`}>
      <span>
        {label}
        {required && <em>*</em>}
      </span>

      {children}

      {helper && <small>{helper}</small>}
    </label>
  );
}

function LockedField({ label, value, placeholder }) {
  return (
    <label className="field locked-field">
      <span>{label}</span>

      <div className="locked-input-wrap">
        <input
          value={value || ''}
          placeholder={placeholder}
          disabled
          readOnly
        />
        <Icons.Lock />
      </div>

      <small>Campo configurado manualmente pela Lumix.</small>
    </label>
  );
}

function CompanyList({
  loading,
  loadingCanais,
  empresas,
  canais,
  resumoPlano,
  onNewCompany,
  onEdit,
  onCreateChannel,
  onConnectChannel,
  onDisconnectChannel,
  onDeactivate,
  onDelete
}) {
  if (loading) {
    return (
      <div className="empty-state">
        <div className="spinner" />
        <p>Carregando empresas...</p>
      </div>
    );
  }

  if (!empresas.length) {
    return (
      <div className="empty-state">
        <div className="empty-icon">
          <Icons.Building />
        </div>

        <h3>Nenhuma empresa cadastrada</h3>
        <p>Cadastre a primeira empresa para começar a configurar a operação.</p>

        <button
          type="button"
          className="primary-button"
          onClick={onNewCompany}
          disabled={!resumoPlano.podeCriar}
        >
          <Icons.Plus />
          Adicionar empresa
        </button>
      </div>
    );
  }

  return (
    <div className="companies-table">
      <div className="table-head">
        <span>Empresa</span>
        <span>Código</span>
        <span>{loadingCanais ? 'Contato' : 'Contato'}</span>
        <span>Fiscal</span>
        <span>Status</span>
        <span />
      </div>

      {empresas.map((emp) => {
        const canal = encontrarCanalDaEmpresa(canais, emp._id);

        return (
        <article key={emp._id} className={`company-row ${emp.ativo === false ? 'inactive' : ''}`}>
          <div className="company-main">
            <div className="company-logo">
              {emp.logoUrl ? (
                <img src={formatImageUrl(emp.logoUrl)} alt={emp.nome} />
              ) : (
                <span>{getEmpresaInitials(emp.nome)}</span>
              )}
            </div>

            <div>
              <strong>{emp.nome}</strong>
              <small>{emp.cnpj ? formatarCNPJ(emp.cnpj) : 'Sem CNPJ'}</small>
            </div>
          </div>

          <div className="cell-muted">
            {emp.codigoLoja || '--'}
            <small>{emp.unidade || 'Matriz'}</small>
          </div>

          <div className="contact-cell">
            <span><Icons.Phone /> {emp.whatsapp || emp.telefone || '--'}</span>
            <span><Icons.Mail /> {emp.email || '--'}</span>
            {canal ? (
              <span className={`channel-inline ${getCanalStatusMeta(canal).tone}`}><Icons.Message /> {canal.nome} · {getCanalStatusMeta(canal).label}</span>
            ) : (
              <span className="channel-inline muted"><Icons.Message /> Sem canal</span>
            )}
          </div>

          <div className="fiscal-cell">
            <FiscalStatusBadge empresa={emp} />

            <small className="badge-caption">
              {emp?.fiscal?.ambiente === 'production' ? 'Produção' : 'Homologação'}
              {' · '}
              {REGIMES_TRIBUTARIOS.find((regime) => regime.value === emp?.fiscal?.regimeTributario)?.label || 'Regime não informado'}
              {empresaTemCertificadoA1(emp) ? ' · A1 ok' : ' · A1 pendente'}
            </small>

            {emp?.fiscal?.statusAnalise === 'em_analise' && (
              <small className="badge-caption">{getPrazoAnaliseTexto(emp)}</small>
            )}
          </div>

          <div>
            <span className={`status-pill ${emp.ativo === false ? 'off' : 'on'}`}>
              {emp.ativo === false ? 'Inativa' : 'Ativa'}
            </span>
          </div>

          <div className="row-actions">
            <button type="button" onClick={() => onEdit(emp)} title="Editar">
              <Icons.Edit />
            </button>

            <button
              type="button"
              className={canal ? `channel-ok ${getCanalStatusMeta(canal).tone}` : ''}
              onClick={() => onCreateChannel(emp)}
              title={canal ? `Gerenciar canal: ${canal.nome}` : 'Criar canal de comunicação'}
              disabled={emp.ativo === false}
            >
              {canal ? <Icons.Check /> : <Icons.Message />}
            </button>

            {canal && (
              <button
                type="button"
                className={getCanalRuntime(canal).connected ? 'channel-disconnect' : 'channel-connect'}
                onClick={() => getCanalRuntime(canal).connected ? onDisconnectChannel(canal, emp) : onConnectChannel(canal, emp)}
                title={getCanalRuntime(canal).connected ? 'Desconectar canal' : 'Conectar canal'}
                disabled={emp.ativo === false}
              >
                <Icons.Power />
              </button>
            )}

            {emp.ativo !== false && (
              <button type="button" onClick={() => onDeactivate(emp)} title="Desativar">
                <Icons.Pause />
              </button>
            )}

            <button type="button" className="danger" onClick={() => onDelete(emp)} title="Excluir definitivamente">
              <Icons.Trash />
            </button>
          </div>
        </article>
        );
      })}
    </div>
  );
}

function CanalConnectionPanel({ canal, empresa, connection, onConnect, onDisconnect, onRefreshStatus }) {
  const runtime = getCanalRuntime(canal || {});
  const mesmoCanal = connection?.canal && getCanalId(connection.canal) === getCanalId(canal);

  const status = mesmoCanal
    ? connection.status || runtime.status
    : runtime.status;

  const connected = mesmoCanal
    ? connection.connected
    : runtime.connected;

  const qrCode = mesmoCanal
    ? connection?.qrCode || runtime.qrCode || ''
    : runtime.qrCode || '';

  const qrSrc = formatQrCodeSrc(qrCode);
  const qrRawValue = getQrCodeRawValue(qrCode);
  const hasQrCode = Boolean(qrSrc || qrRawValue);
  const meta = getCanalStatusMeta({ ...canal, runtime: { ...runtime, status, connected, qrCode } });
  const loading = Boolean(mesmoCanal && (connection?.loading || connection?.checking));
  const stopping = status === 'DISCONNECTING';
  const connecting = !connected && ['INITIALIZING', 'QRCODE', 'LOADING'].includes(String(status || '').toUpperCase());
  const canStopConnection = Boolean(!connected && getCanalId(canal) && (connection?.connectLock || connecting || hasQrCode || loading));
  const lastStatusAt = formatarHoraCurta(connection?.lastStatusAt || runtime.lastStatusAt);

  if (!canal) {
    return null;
  }

  return (
    <div className={`channel-connection-card premium ${meta.tone}`}>
      <div className="channel-connection-head">
        <div>
          <span>Status da conexão</span>
          <strong>{meta.label}</strong>
          <p>{connection?.error || meta.description}</p>
        </div>

        <span className={`connection-badge ${meta.tone}`}>
          {connected ? <Icons.Check /> : status === 'QRCODE' ? <Icons.Qr /> : <Icons.Power />}
          {meta.label}
        </span>
      </div>

      {!connected && (
        <div className="connection-live-strip">
          <div className={`live-dot ${qrSrc ? 'qr' : loading || connecting ? 'loading' : ''}`} />
          <span>
            {hasQrCode
              ? 'QR Code ativo aguardando leitura'
              : loading || connecting
                ? 'Preparando sessão segura do WhatsApp'
                : 'Canal pronto para iniciar conexão'}
          </span>

          {lastStatusAt && <small>Atualizado {lastStatusAt}</small>}
        </div>
      )}

      {hasQrCode && !connected && (
        <div className="qr-card premium-qr">
          <div className="qr-box">
            {qrSrc ? (
              <img src={qrSrc} alt="QR Code do WhatsApp" />
            ) : (
              <QRCodeCanvas value={qrRawValue} size={220} level="M" includeMargin />
            )}
          </div>

          <div className="qr-copy">
            <strong>Escaneie para ativar este canal</strong>
            <p>Abra o WhatsApp no celular, toque em <b>Aparelhos conectados</b> e leia o QR Code.</p>
            <small>Se ninguém escanear, esta sessão pode continuar aguardando. Use <b>Parar conexão</b> para encerrar com segurança.</small>
          </div>
        </div>
      )}

      {!hasQrCode && !connected && (connection?.connectLock || status === 'INITIALIZING' || status === 'QRCODE' || loading) && (
        <div className="qr-waiting-box premium-wait">
          <div className="loader-orbit">
            <span />
          </div>

          <div>
            <strong>Gerando QR Code...</strong>
            <p>Estamos abrindo uma sessão exclusiva para este canal. Isso pode levar alguns segundos.</p>
            <div className="loading-skeleton">
              <span />
              <span />
            </div>
          </div>
        </div>
      )}

      <div className="connection-actions">
        <button type="button" className="secondary-button" onClick={() => onRefreshStatus(canal, empresa)} disabled={loading || stopping}>
          <Icons.Refresh /> {loading && !stopping ? 'Consultando...' : 'Atualizar'}
        </button>

        {canStopConnection && (
          <button type="button" className="stop-button" onClick={() => onDisconnect(canal, empresa)} disabled={stopping}>
            <Icons.Power /> {stopping ? 'Parando...' : 'Parar conexão'}
          </button>
        )}

        {connected ? (
          <button type="button" className="danger-button" onClick={() => onDisconnect(canal, empresa)} disabled={loading || stopping}>
            <Icons.Power /> {stopping ? 'Desconectando...' : 'Desconectar'}
          </button>
        ) : (
          <button type="button" className="primary-button" onClick={() => onConnect(canal, empresa)} disabled={loading || stopping}>
            <Icons.Qr /> {loading ? 'Conectando...' : hasQrCode ? 'Gerar novo QR' : 'Conectar canal'}
          </button>
        )}
      </div>
    </div>
  );
}


function ChannelModal({
  empresa,
  canal,
  connection,
  form,
  saving,
  onChange,
  onClose,
  onSubmit,
  onConnect,
  onDisconnect,
  onRefreshStatus
}) {
  const canalCriado = Boolean(canal && getCanalId(canal));

  return (
    <div className="modal-backdrop" role="presentation">
      <section className="channel-modal" role="dialog" aria-modal="true">
        <div className="modal-head">
          <div>
            <span>Canal de comunicação</span>
            <h2>{empresa?.nome || 'Empresa'}</h2>
            <p>
              {canalCriado
                ? 'Gerencie a conexão do WhatsApp desta empresa. O QR Code aparece aqui quando você clicar em conectar.'
                : 'Cadastre o nome e o número do WhatsApp. Depois clique em conectar para exibir o QR Code.'}
            </p>
          </div>

          <button type="button" onClick={onClose} disabled={saving}>
            ×
          </button>
        </div>

        <form onSubmit={onSubmit} className="modal-body">
          <Field label="Nome do canal" required>
            <input
              required
              name="nome"
              value={form.nome}
              onChange={onChange}
              placeholder="Ex: WhatsApp Loja Centro"
              disabled={canalCriado || saving}
            />
          </Field>

          <Field label="Número do WhatsApp">
            <input
              name="numero"
              value={form.numero}
              onChange={onChange}
              placeholder="(00) 00000-0000"
              disabled={canalCriado || saving}
            />
          </Field>

          <label className="switch-line modal-switch">
            <input
              type="checkbox"
              name="principal"
              checked={form.principal}
              onChange={onChange}
              disabled={canalCriado || saving}
            />
            <span />
            Definir como canal principal desta empresa
          </label>

          {!canalCriado && (
            <div className="modal-note">
              <Icons.Shield />
              <p>
                Primeiro crie o canal. Em seguida, clique em conectar para abrir o QR Code e vincular o WhatsApp da loja.
              </p>
            </div>
          )}

          {canalCriado && (
            <CanalConnectionPanel
              canal={canal}
              empresa={empresa}
              connection={connection}
              onConnect={onConnect}
              onDisconnect={onDisconnect}
              onRefreshStatus={onRefreshStatus}
            />
          )}

          <div className="modal-actions">
            <button type="button" className="secondary-button" onClick={onClose} disabled={saving}>
              Fechar
            </button>

            {!canalCriado && (
              <button type="submit" className="primary-button" disabled={saving}>
                {saving ? 'Criando...' : 'Criar canal'}
              </button>
            )}
          </div>
        </form>
      </section>
    </div>
  );
}


const GlobalStyles = () => (
  <style>{`
    :root {
      --bg: #f8fafd;
      --surface: #ffffff;
      --surface-soft: #f6f8fb;
      --hover: #f1f3f4;

      --text: #202124;
      --muted: #5f6368;
      --soft: #80868b;

      --line: #dadce0;
      --line-soft: #edf0f3;

      --blue: #1a73e8;
      --green: #188038;
      --red: #d93025;
      --amber: #f9ab00;

      --radius: 14px;
      --font: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Inter, Arial, sans-serif;
    }

    * {
      box-sizing: border-box;
      margin: 0;
      padding: 0;
      -webkit-tap-highlight-color: transparent;
    }

    body {
      font-family: var(--font);
      color: var(--text);
      background: var(--bg);
      font-size: 14px;
      -webkit-font-smoothing: antialiased;
      text-rendering: geometricPrecision;
    }

    button,
    input,
    select {
      font-family: inherit;
    }

    .empresas-page {
      width: min(1080px, calc(100% - 40px));
      margin: 0 auto;
      padding: 32px 0 42px;
    }

    .page-head {
      margin-bottom: 22px;
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      gap: 16px;
    }

    .page-head-left {
      display: flex;
      align-items: flex-start;
      gap: 13px;
    }

    .eyebrow {
      display: block;
      margin-bottom: 6px;
      color: var(--muted);
      font-size: 12px;
      font-weight: 500;
    }

    .page-head h1 {
      color: var(--text);
      font-size: 30px;
      line-height: 1.12;
      font-weight: 500;
      letter-spacing: -0.035em;
    }

    .page-head p {
      margin-top: 4px;
      color: var(--muted);
      font-size: 14px;
    }

    .page-actions {
      display: flex;
      align-items: center;
      gap: 8px;
    }

    .icon-button,
    .row-actions button {
      border: 1px solid var(--line);
      border-radius: 999px;
      display: grid;
      place-items: center;
      color: var(--muted);
      background: #fff;
      cursor: pointer;
    }

    .icon-button {
      width: 36px;
      height: 36px;
    }

    .icon-button svg,
    .row-actions svg {
      width: 16px;
      height: 16px;
    }

    .icon-button:hover,
    .row-actions button:hover {
      color: var(--text);
      background: var(--hover);
    }

    .primary-button,
    .secondary-button {
      height: 36px;
      padding: 0 13px;
      border-radius: 999px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 7px;
      font-size: 13px;
      font-weight: 500;
      cursor: pointer;
      white-space: nowrap;
      transition: .14s ease;
    }

    .primary-button {
      border: 1px solid #111318;
      color: #fff;
      background: #111318;
    }

    .primary-button:hover:not(:disabled) {
      background: #000;
    }

    .primary-button:disabled {
      opacity: .45;
      cursor: not-allowed;
    }

    .primary-button svg,
    .secondary-button svg {
      width: 15px;
      height: 15px;
    }

    .secondary-button {
      border: 1px solid var(--line);
      color: var(--text);
      background: #fff;
    }

    .secondary-button:hover {
      background: var(--hover);
    }

    .secondary-button.compact {
      height: 32px;
      padding-inline: 11px;
    }

    .plan-panel {
      margin-bottom: 24px;
      border: 1px solid var(--line);
      border-radius: var(--radius);
      display: grid;
      grid-template-columns: 1fr 340px;
      overflow: hidden;
      background: var(--surface);
    }

    .plan-main {
      padding: 18px;
      border-right: 1px solid var(--line);
    }

    .plan-main span {
      display: block;
      color: var(--muted);
      font-size: 12px;
      margin-bottom: 4px;
    }

    .plan-main strong {
      display: block;
      color: var(--text);
      font-size: 19px;
      line-height: 1.2;
      font-weight: 600;
    }

    .plan-main p {
      margin-top: 6px;
      color: var(--muted);
      font-size: 13px;
      line-height: 1.5;
    }

    .usage-box {
      padding: 18px;
      display: grid;
      align-content: center;
      gap: 10px;
    }

    .usage-row,
    .usage-foot {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 12px;
    }

    .usage-row span,
    .usage-foot span {
      color: var(--muted);
      font-size: 12px;
    }

    .usage-row strong {
      color: var(--text);
      font-size: 18px;
      font-weight: 600;
    }

    .progress-track {
      height: 6px;
      border-radius: 999px;
      background: var(--line-soft);
      overflow: hidden;
    }

    .progress-fill {
      height: 100%;
      border-radius: 999px;
      background: var(--blue);
      transition: width .2s ease;
    }

    .usage-foot button {
      border: 0;
      color: var(--blue);
      background: transparent;
      font-size: 12px;
      font-weight: 500;
      cursor: pointer;
    }

    .page-content {
      min-height: 320px;
    }

    .form-card,
    .companies-table,
    .empty-state {
      border: 1px solid var(--line);
      border-radius: var(--radius);
      background: #fff;
      overflow: hidden;
    }

    .form-title {
      padding: 18px;
      border-bottom: 1px solid var(--line);
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      gap: 16px;
    }

    .form-title h2 {
      color: var(--text);
      font-size: 18px;
      font-weight: 600;
    }

    .form-title p {
      margin-top: 4px;
      color: var(--muted);
      font-size: 13px;
      line-height: 1.45;
    }

    .form-section {
      padding: 18px;
      border-bottom: 1px solid var(--line);
      display: grid;
      grid-template-columns: 210px minmax(0, 1fr);
      gap: 24px;
    }

    .form-section aside h3 {
      color: var(--text);
      font-size: 13px;
      font-weight: 600;
    }

    .form-section aside p {
      margin-top: 5px;
      color: var(--muted);
      font-size: 12px;
      line-height: 1.45;
    }

    .form-grid,
    .advanced-grid {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 14px;
    }

    .field {
      display: grid;
      gap: 6px;
    }

    .field.full {
      grid-column: 1 / -1;
    }

    .field > span {
      color: var(--text);
      font-size: 12px;
      font-weight: 500;
    }

    .field em {
      margin-left: 3px;
      color: var(--red);
      font-style: normal;
    }

    .field small {
      color: var(--muted);
      font-size: 11px;
      line-height: 1.35;
    }

    .field input,
    .field select,
    .advanced-section input,
    .advanced-section select {
      width: 100%;
      height: 38px;
      padding: 0 10px;
      border: 1px solid var(--line);
      border-radius: 10px;
      color: var(--text);
      background: #fff;
      font-size: 13px;
      outline: none;
    }

    .field input:focus,
    .field select:focus,
    .advanced-section input:focus,
    .advanced-section select:focus {
      border-color: var(--blue);
      box-shadow: 0 0 0 3px rgba(26, 115, 232, .10);
    }

    .locked-input-wrap {
      position: relative;
      display: flex;
      align-items: center;
    }

    .locked-input-wrap input {
      padding-right: 38px;
      color: var(--muted);
      background: #f8fafd;
      cursor: not-allowed;
    }

    .locked-input-wrap svg {
      position: absolute;
      right: 11px;
      width: 15px;
      height: 15px;
      color: var(--soft);
      pointer-events: none;
    }

    .locked-field small {
      color: var(--soft);
    }

    .logo-uploader {
      width: 120px;
      height: 120px;
      border: 1px dashed var(--line);
      border-radius: 16px;
      display: grid;
      place-items: center;
      overflow: hidden;
      color: var(--muted);
      background: var(--surface-soft);
      cursor: pointer;
    }

    .logo-uploader:hover {
      background: var(--hover);
    }

    .logo-uploader img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .logo-uploader div {
      display: grid;
      place-items: center;
      gap: 6px;
      text-align: center;
    }

    .logo-uploader svg {
      width: 22px;
      height: 22px;
    }

    .logo-uploader span {
      color: var(--text);
      font-size: 12px;
      font-weight: 500;
    }

    .logo-uploader small {
      color: var(--muted);
      font-size: 10px;
    }

    .switch-line {
      height: 38px;
      display: flex;
      align-items: center;
      gap: 10px;
      color: var(--text);
      font-size: 13px;
      cursor: pointer;
    }

    .switch-line input {
      display: none;
    }

    .switch-line span {
      width: 34px;
      height: 20px;
      border-radius: 999px;
      background: var(--line);
      position: relative;
      transition: .15s ease;
    }

    .switch-line span::after {
      content: '';
      position: absolute;
      top: 2px;
      left: 2px;
      width: 16px;
      height: 16px;
      border-radius: 999px;
      background: #fff;
      transition: .15s ease;
    }

    .switch-line input:checked + span {
      background: #111318;
    }

    .switch-line input:checked + span::after {
      transform: translateX(14px);
    }

    .color-field {
      display: grid;
      grid-template-columns: 38px 1fr;
      gap: 8px;
    }

    .color-field input[type="color"] {
      padding: 3px;
      cursor: pointer;
    }

    .advanced-section {
      border-bottom: 1px solid var(--line);
    }

    .advanced-section summary {
      padding: 16px 18px;
      display: flex;
      justify-content: space-between;
      gap: 12px;
      cursor: pointer;
      list-style: none;
    }

    .advanced-section summary::-webkit-details-marker {
      display: none;
    }

    .advanced-section summary span {
      color: var(--text);
      font-size: 13px;
      font-weight: 600;
    }

    .advanced-section summary small {
      color: var(--muted);
      font-size: 12px;
    }

    .advanced-grid {
      padding: 0 18px 18px;
    }

    .provider-fixed-card {
      min-height: 72px;
      padding: 12px;
      border: 1px solid #d2e3fc;
      border-radius: 12px;
      display: grid;
      align-content: center;
      gap: 3px;
      background: #eef5ff;
    }

    .provider-fixed-card span {
      color: var(--blue);
      font-size: 11px;
      font-weight: 500;
    }

    .provider-fixed-card strong {
      color: var(--text);
      font-size: 15px;
      font-weight: 600;
    }

    .provider-fixed-card small {
      color: var(--muted);
      font-size: 11px;
      line-height: 1.35;
    }

    .certificate-card {
      grid-column: 1 / -1;
      padding: 14px;
      border: 1px solid var(--line);
      border-radius: 14px;
      display: grid;
      gap: 12px;
      background: var(--surface-soft);
    }

    .certificate-head {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      gap: 12px;
    }

    .certificate-head strong {
      display: block;
      color: var(--text);
      font-size: 13px;
      font-weight: 600;
    }

    .certificate-head span {
      display: block;
      margin-top: 3px;
      color: var(--muted);
      font-size: 12px;
      line-height: 1.4;
    }

    .certificate-status {
      width: fit-content;
      padding: 4px 8px;
      border: 1px solid var(--line);
      border-radius: 999px;
      color: var(--muted);
      background: #fff;
      font-size: 11px;
      font-weight: 500;
      white-space: nowrap;
    }

    .certificate-status.ok {
      color: var(--green);
      border-color: #cce8d5;
      background: #f1f8f4;
    }

    .certificate-uploader {
      min-height: 58px;
      padding: 12px;
      border: 1px dashed var(--line);
      border-radius: 12px;
      display: flex;
      align-items: center;
      gap: 11px;
      color: var(--muted);
      background: #fff;
      cursor: pointer;
    }

    .certificate-uploader:hover {
      background: var(--hover);
    }

    .certificate-uploader svg {
      width: 21px;
      height: 21px;
      color: var(--blue);
      flex-shrink: 0;
    }

    .certificate-uploader strong {
      display: block;
      color: var(--text);
      font-size: 13px;
      font-weight: 600;
      word-break: break-word;
    }

    .certificate-uploader span {
      display: block;
      margin-top: 2px;
      color: var(--muted);
      font-size: 11px;
    }

    .certificate-note {
      color: var(--muted);
      font-size: 11px;
      line-height: 1.45;
    }

    .fiscal-analysis-card {
      grid-column: 1 / -1;
      padding: 14px;
      border: 1px solid var(--line);
      border-radius: 14px;
      display: grid;
      grid-template-columns: auto minmax(0, 1fr) auto;
      align-items: center;
      gap: 12px;
      background: #fff;
    }

    .fiscal-analysis-card.success {
      border-color: #cce8d5;
      background: #f1f8f4;
    }

    .fiscal-analysis-card.warning {
      border-color: #fde68a;
      background: #fffbeb;
    }

    .fiscal-analysis-card.danger {
      border-color: #f4c7c3;
      background: #fceeee;
    }

    .fiscal-analysis-icon {
      width: 36px;
      height: 36px;
      border-radius: 999px;
      display: grid;
      place-items: center;
      color: var(--muted);
      background: #fff;
      border: 1px solid var(--line);
    }

    .fiscal-analysis-card.success .fiscal-analysis-icon {
      color: var(--green);
      border-color: #cce8d5;
    }

    .fiscal-analysis-card.warning .fiscal-analysis-icon {
      color: #b45309;
      border-color: #fde68a;
    }

    .fiscal-analysis-card.danger .fiscal-analysis-icon {
      color: var(--red);
      border-color: #f4c7c3;
    }

    .fiscal-analysis-icon svg {
      width: 17px;
      height: 17px;
    }

    .fiscal-analysis-copy {
      min-width: 0;
      display: grid;
      gap: 2px;
    }

    .fiscal-analysis-copy span {
      color: var(--muted);
      font-size: 11px;
      font-weight: 500;
    }

    .fiscal-analysis-copy strong {
      color: var(--text);
      font-size: 14px;
      font-weight: 600;
    }

    .fiscal-analysis-copy p {
      color: var(--muted);
      font-size: 12px;
      line-height: 1.4;
    }

    .fiscal-analysis-copy small {
      color: var(--soft);
      font-size: 11px;
      line-height: 1.4;
    }


    .fiscal-cell {
      display: grid;
      gap: 3px;
      justify-items: start;
    }

    .fiscal-status-badge {
      width: fit-content;
      padding: 4px 8px;
      border-radius: 999px;
      display: inline-flex;
      align-items: center;
      gap: 5px;
      font-size: 11px;
      font-weight: 500;
      border: 1px solid var(--line);
      color: var(--muted);
      background: #fff;
    }

    .fiscal-status-badge svg {
      width: 12px;
      height: 12px;
    }

    .fiscal-status-badge.success {
      color: var(--green);
      background: #f1f8f4;
      border-color: #cce8d5;
    }

    .fiscal-status-badge.warning {
      color: #b45309;
      background: #fffbeb;
      border-color: #fde68a;
    }

    .fiscal-status-badge.danger {
      color: var(--red);
      background: #fceeee;
      border-color: #f4c7c3;
    }


    .form-actions {
      padding: 16px 18px;
      display: flex;
      justify-content: flex-end;
      gap: 8px;
      background: var(--surface-soft);
    }

    .companies-table {
      display: grid;
    }

    .table-head,
    .company-row {
      display: grid;
      grid-template-columns: minmax(260px, 1.5fr) minmax(120px, .7fr) minmax(180px, 1fr) minmax(150px, .8fr) 90px 120px;
      align-items: center;
    }

    .table-head {
      min-height: 42px;
      padding: 0 14px;
      border-bottom: 1px solid var(--line);
      color: var(--muted);
      background: var(--surface-soft);
      font-size: 12px;
      font-weight: 500;
    }

    .company-row {
      min-height: 78px;
      padding: 12px 14px;
      border-bottom: 1px solid var(--line-soft);
      gap: 12px;
    }

    .company-row:last-child {
      border-bottom: 0;
    }

    .company-row:hover {
      background: #fbfcfe;
    }

    .company-row.inactive {
      opacity: .62;
    }

    .company-main {
      min-width: 0;
      display: flex;
      align-items: center;
      gap: 11px;
    }

    .company-logo {
      width: 42px;
      height: 42px;
      border: 1px solid var(--line);
      border-radius: 12px;
      display: grid;
      place-items: center;
      overflow: hidden;
      color: var(--text);
      background: var(--surface-soft);
      flex-shrink: 0;
    }

    .company-logo img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .company-logo span {
      font-size: 12px;
      font-weight: 600;
    }

    .company-main strong,
    .company-main small,
    .cell-muted,
    .cell-muted small,
    .contact-cell span {
      display: block;
      min-width: 0;
    }

    .company-main strong {
      overflow: hidden;
      color: var(--text);
      font-size: 14px;
      font-weight: 600;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .company-main small,
    .cell-muted small,
    .badge-caption {
      margin-top: 2px;
      color: var(--muted);
      font-size: 12px;
    }

    .cell-muted {
      color: var(--text);
      font-size: 13px;
    }

    .contact-cell {
      display: grid;
      gap: 4px;
    }

    .contact-cell span {
      overflow: hidden;
      color: var(--muted);
      font-size: 12px;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .contact-cell svg {
      width: 13px;
      height: 13px;
      margin-right: 5px;
      vertical-align: -2px;
    }

    .badge,
    .status-pill {
      width: fit-content;
      padding: 4px 8px;
      border-radius: 999px;
      display: inline-flex;
      align-items: center;
      font-size: 11px;
      font-weight: 500;
    }

    .badge.success {
      color: var(--green);
      background: #f1f8f4;
      border: 1px solid #cce8d5;
    }

    .badge.neutral {
      color: var(--muted);
      background: #fff;
      border: 1px solid var(--line);
    }

    .status-pill.on {
      color: var(--green);
      background: #f1f8f4;
    }

    .status-pill.off {
      color: var(--red);
      background: #fceeee;
    }

    .row-actions {
      display: flex;
      justify-content: flex-end;
      gap: 6px;
    }

    .row-actions button {
      width: 32px;
      height: 32px;
    }

    .row-actions button.danger:hover {
      color: var(--red);
      border-color: #f4c7c3;
      background: #fceeee;
    }

    .row-actions button.channel-ok {
      color: var(--green);
      border-color: #cce8d5;
      background: #f1f8f4;
    }

    .row-actions button:disabled {
      opacity: .45;
      cursor: not-allowed;
    }

    .channel-inline {
      color: var(--green) !important;
    }

    .channel-inline.muted {
      color: var(--muted) !important;
    }

    .channel-inline.success {
      color: var(--green) !important;
    }

    .channel-inline.warning {
      color: #b45309 !important;
    }

    .channel-inline.danger {
      color: var(--red) !important;
    }

    .row-actions button.channel-connect {
      color: var(--blue);
      border-color: #d2e3fc;
      background: #eef5ff;
    }

    .row-actions button.channel-disconnect {
      color: var(--red);
      border-color: #f4c7c3;
      background: #fceeee;
    }

    .danger-button {
      height: 36px;
      padding: 0 13px;
      border: 1px solid #f4c7c3;
      border-radius: 999px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 7px;
      color: var(--red);
      background: #fceeee;
      font-size: 13px;
      font-weight: 500;
      cursor: pointer;
      white-space: nowrap;
    }

    .danger-button svg {
      width: 15px;
      height: 15px;
    }

    .danger-button:disabled {
      opacity: .55;
      cursor: not-allowed;
    }

    .modal-backdrop {
      position: fixed;
      inset: 0;
      z-index: 300;
      padding: 18px;
      display: grid;
      place-items: center;
      background: rgba(32, 33, 36, .46);
    }

    .channel-modal {
      width: min(460px, 100%);
      border: 1px solid var(--line);
      border-radius: 16px;
      overflow: hidden;
      background: #fff;
      box-shadow: 0 18px 60px rgba(32, 33, 36, .16);
    }

    .modal-head {
      padding: 18px;
      border-bottom: 1px solid var(--line);
      display: flex;
      justify-content: space-between;
      gap: 16px;
    }

    .modal-head span {
      display: block;
      color: var(--muted);
      font-size: 12px;
      margin-bottom: 5px;
    }

    .modal-head h2 {
      color: var(--text);
      font-size: 19px;
      line-height: 1.15;
      font-weight: 600;
    }

    .modal-head p {
      margin-top: 5px;
      color: var(--muted);
      font-size: 13px;
      line-height: 1.45;
    }

    .modal-head button {
      width: 32px;
      height: 32px;
      border: 1px solid var(--line);
      border-radius: 999px;
      color: var(--muted);
      background: #fff;
      font-size: 20px;
      line-height: 1;
      cursor: pointer;
    }

    .modal-head button:hover:not(:disabled) {
      color: var(--text);
      background: var(--hover);
    }

    .modal-body {
      padding: 18px;
      display: grid;
      gap: 14px;
    }

    .modal-switch {
      height: auto;
      min-height: 32px;
    }

    .modal-note {
      padding: 11px;
      border: 1px solid var(--line);
      border-radius: 12px;
      display: flex;
      gap: 9px;
      color: var(--muted);
      background: var(--surface-soft);
    }

    .modal-note svg {
      width: 17px;
      height: 17px;
      color: var(--green);
      flex-shrink: 0;
    }

    .modal-note p {
      color: var(--muted);
      font-size: 12px;
      line-height: 1.45;
    }

    .channel-connection-card {
      padding: 13px;
      border: 1px solid var(--line);
      border-radius: 14px;
      display: grid;
      gap: 12px;
      background: var(--surface-soft);
    }

    .channel-connection-card.success {
      border-color: #cce8d5;
      background: #f1f8f4;
    }

    .channel-connection-card.warning {
      border-color: #fde68a;
      background: #fffbeb;
    }

    .channel-connection-card.danger {
      border-color: #f4c7c3;
      background: #fceeee;
    }

    .channel-connection-head {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      gap: 12px;
    }

    .channel-connection-head span {
      color: var(--muted);
      font-size: 11px;
      font-weight: 500;
    }

    .channel-connection-head strong {
      display: block;
      margin-top: 3px;
      color: var(--text);
      font-size: 14px;
      font-weight: 600;
    }

    .channel-connection-head p {
      margin-top: 3px;
      color: var(--muted);
      font-size: 12px;
      line-height: 1.4;
    }

    .connection-badge {
      width: fit-content;
      padding: 5px 8px;
      border-radius: 999px;
      display: inline-flex;
      align-items: center;
      gap: 5px;
      border: 1px solid var(--line);
      color: var(--muted);
      background: #fff;
      font-size: 11px;
      font-weight: 600;
      white-space: nowrap;
    }

    .connection-badge svg {
      width: 13px;
      height: 13px;
    }

    .connection-badge.success {
      color: var(--green);
      border-color: #cce8d5;
      background: #f1f8f4;
    }

    .connection-badge.warning {
      color: #b45309;
      border-color: #fde68a;
      background: #fffbeb;
    }

    .connection-badge.danger {
      color: var(--red);
      border-color: #f4c7c3;
      background: #fceeee;
    }

    .qr-card,
    .qr-waiting-box {
      padding: 12px;
      border: 1px solid var(--line);
      border-radius: 12px;
      display: grid;
      grid-template-columns: 132px minmax(0, 1fr);
      gap: 12px;
      align-items: center;
      background: #fff;
    }

    .qr-box canvas {
      width: 100% !important;
      max-width: 220px;
      height: auto !important;
      display: block;
    }

    .qr-box {
      width: 132px;
      height: 132px;
      border: 1px solid var(--line);
      border-radius: 12px;
      display: grid;
      place-items: center;
      background: #fff;
      overflow: hidden;
    }

    .qr-box img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }

    .qr-card strong,
    .qr-waiting-box strong {
      color: var(--text);
      font-size: 13px;
      font-weight: 600;
    }

    .qr-card p,
    .qr-waiting-box p {
      margin-top: 4px;
      color: var(--muted);
      font-size: 12px;
      line-height: 1.45;
    }

    .qr-waiting-box {
      grid-template-columns: 28px 1fr;
    }

    .channel-connection-card.premium {
      position: relative;
      overflow: hidden;
      background:
        linear-gradient(180deg, rgba(255,255,255,.92), rgba(255,255,255,.82)),
        var(--surface-soft);
    }

    .channel-connection-card.premium::before {
      content: '';
      position: absolute;
      inset: 0 0 auto;
      height: 3px;
      background: linear-gradient(90deg, var(--blue), #34a853, #fbbc04);
      opacity: .85;
    }

    .connection-live-strip {
      min-height: 34px;
      padding: 7px 10px;
      border: 1px solid var(--line-soft);
      border-radius: 999px;
      display: flex;
      align-items: center;
      gap: 8px;
      color: var(--muted);
      background: rgba(255,255,255,.72);
      font-size: 11px;
      font-weight: 600;
    }

    .connection-live-strip small {
      margin-left: auto;
      color: var(--soft);
      font-size: 10px;
      font-weight: 500;
      white-space: nowrap;
    }

    .live-dot {
      width: 8px;
      height: 8px;
      border-radius: 999px;
      background: var(--soft);
      flex-shrink: 0;
    }

    .live-dot.loading,
    .live-dot.qr {
      background: var(--amber);
      box-shadow: 0 0 0 0 rgba(249,171,0,.45);
      animation: pulseDot 1.35s ease-in-out infinite;
    }

    .live-dot.qr {
      background: var(--blue);
      box-shadow: 0 0 0 0 rgba(26,115,232,.38);
    }

    .premium-qr {
      box-shadow: inset 0 0 0 1px rgba(255,255,255,.7);
    }

    .qr-copy small {
      display: block;
      margin-top: 8px;
      color: var(--soft);
      font-size: 11px;
      line-height: 1.45;
    }

    .premium-wait {
      position: relative;
      overflow: hidden;
    }

    .premium-wait::after {
      content: '';
      position: absolute;
      inset: 0;
      background: linear-gradient(90deg, transparent, rgba(255,255,255,.62), transparent);
      transform: translateX(-100%);
      animation: shimmer 1.65s infinite;
      pointer-events: none;
    }

    .loader-orbit {
      width: 28px;
      height: 28px;
      border-radius: 999px;
      border: 1px solid var(--line);
      display: grid;
      place-items: center;
      background: #fff;
    }

    .loader-orbit span {
      width: 16px;
      height: 16px;
      border-radius: 999px;
      border: 2px solid #e8eaed;
      border-top-color: var(--blue);
      animation: spin .8s linear infinite;
    }

    .loading-skeleton {
      margin-top: 9px;
      display: grid;
      gap: 5px;
    }

    .loading-skeleton span {
      height: 7px;
      border-radius: 999px;
      background: linear-gradient(90deg, #edf0f3, #fff, #edf0f3);
      background-size: 200% 100%;
      animation: skeletonMove 1.2s infinite;
    }

    .loading-skeleton span:first-child {
      width: 72%;
    }

    .loading-skeleton span:last-child {
      width: 48%;
    }

    .stop-button {
      height: 36px;
      padding: 0 13px;
      border: 1px solid #fed7aa;
      border-radius: 999px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 7px;
      color: #c2410c;
      background: #fff7ed;
      font-size: 12px;
      font-weight: 600;
      cursor: pointer;
      white-space: nowrap;
    }

    .stop-button:hover:not(:disabled) {
      border-color: #fdba74;
      background: #ffedd5;
    }

    .stop-button:disabled {
      opacity: .6;
      cursor: wait;
    }

    .stop-button svg {
      width: 15px;
      height: 15px;
    }

    @keyframes pulseDot {
      0% { box-shadow: 0 0 0 0 rgba(26,115,232,.32); }
      70% { box-shadow: 0 0 0 8px rgba(26,115,232,0); }
      100% { box-shadow: 0 0 0 0 rgba(26,115,232,0); }
    }

    @keyframes shimmer {
      100% { transform: translateX(100%); }
    }

    @keyframes skeletonMove {
      0% { background-position: 200% 0; }
      100% { background-position: -200% 0; }
    }

    .connection-actions {
      display: flex;
      justify-content: flex-end;
      gap: 8px;
      flex-wrap: wrap;
    }

    .modal-actions {
      display: flex;
      justify-content: flex-end;
      gap: 8px;
      padding-top: 4px;
    }



    .empty-state {
      min-height: 320px;
      padding: 30px;
      display: grid;
      place-items: center;
      align-content: center;
      gap: 10px;
      text-align: center;
    }

    .empty-icon {
      width: 48px;
      height: 48px;
      border: 1px solid var(--line);
      border-radius: 999px;
      display: grid;
      place-items: center;
      color: var(--muted);
      background: var(--surface-soft);
    }

    .empty-icon svg {
      width: 22px;
      height: 22px;
    }

    .empty-state h3 {
      color: var(--text);
      font-size: 16px;
      font-weight: 600;
    }

    .empty-state p {
      max-width: 360px;
      color: var(--muted);
      font-size: 13px;
      line-height: 1.5;
    }

    .spinner {
      width: 22px;
      height: 22px;
      border: 2px solid var(--line);
      border-top-color: var(--blue);
      border-radius: 999px;
      animation: spin .8s linear infinite;
    }

    .toast {
      position: fixed;
      left: 50%;
      bottom: 18px;
      z-index: 200;
      transform: translateX(-50%);
      max-width: min(520px, calc(100% - 28px));
      padding: 10px 14px;
      border: 1px solid var(--line);
      border-radius: 999px;
      color: var(--text);
      background: #fff;
      font-size: 13px;
    }

    .toast.success {
      color: var(--green);
      border-color: #cce8d5;
      background: #f1f8f4;
    }

    .toast.error {
      color: var(--red);
      border-color: #f4c7c3;
      background: #fceeee;
    }

    .toast.info {
      color: var(--blue);
      border-color: #d2e3fc;
      background: #eef5ff;
    }

    @keyframes spin {
      to {
        transform: rotate(360deg);
      }
    }

    @media (max-width: 980px) {
      .empresas-page {
        width: min(100% - 32px, 1080px);
        padding-top: 24px;
      }

      .page-head,
      .plan-panel {
        grid-template-columns: 1fr;
      }

      .page-head {
        align-items: flex-start;
        flex-direction: column;
      }

      .page-actions {
        width: 100%;
      }

      .page-actions button {
        flex: 1;
      }

      .plan-panel {
        display: grid;
      }

      .plan-main {
        border-right: 0;
        border-bottom: 1px solid var(--line);
      }

      .form-section {
        grid-template-columns: 1fr;
        gap: 14px;
      }

      .table-head {
        display: none;
      }

      .companies-table {
        border: 0;
        background: transparent;
        gap: 10px;
      }

      .company-row {
        border: 1px solid var(--line);
        border-radius: var(--radius);
        display: grid;
        grid-template-columns: 1fr auto;
        align-items: start;
        background: #fff;
      }

      .company-row > div:not(.company-main):not(.row-actions) {
        grid-column: 1 / -1;
      }

      .contact-cell {
        margin-top: 4px;
      }

      .row-actions {
        grid-column: 2;
        grid-row: 1;
      }
    }

    @media (max-width: 640px) {
      .empresas-page {
        width: min(100% - 24px, 1080px);
      }

      .page-head h1 {
        font-size: 25px;
      }

      .page-actions {
        flex-direction: column;
      }

      .page-actions button {
        width: 100%;
      }

      .form-grid,
      .advanced-grid {
        grid-template-columns: 1fr;
      }

      .certificate-head {
        flex-direction: column;
      }

      .fiscal-analysis-card {
        grid-template-columns: 1fr;
      }


      .field.full {
        grid-column: auto;
      }

      .form-title,
      .form-actions {
        flex-direction: column;
      }

      .form-actions button {
        width: 100%;
      }

      .company-row {
        grid-template-columns: 1fr;
      }

      .row-actions {
        grid-column: 1;
        grid-row: auto;
        justify-content: flex-start;
      }
    }
  `}</style>
);
